export default {
    carousel:{
        prev:'',
        next:'',
        ariaLabel:{
            delimiter: ''
        }
    },
    login:{
        accountLogin:'账户登录',
        codeLogin:'验证码登录',
        accountOrPhone:'用户名/手机号',
        password:'密码',
        NowLogin:'立即登录',
        pLogin:'该账号可登录长光卫星实时服务门户下所有产品',
        areaCode:'区号',
        phoneNumber:'手机号',
        validCode:'验证码',
        getCode:'获取验证码',
        resend:'重新发送',
        forgetPasswd:'忘记密码',
        forgetPasswdMarginLeft:'9rem',
        freeRegister:'免费注册',
        AccountNoEmpty:'用户名/手机号不能为空',
        passWdNoEmpty:'密码不能为空',
        NoEmpty:'该项不能为空',
        phoneError:'手机号格式有误',
        phoneError1:'手机号需为数字',
        error1:'用户名或密码错误',
        error2:'手机号或验证码错误',
        error3:'用户名/手机号未注册',
        error4:'网络错误',
        error5:'手机号未注册',
        error6:'手机号格式错误',
        error7:'手机号不能为空',
    },
    register:{
        register:'注册',
        regNewAccount:'注册新的账号',
        haveSoCreate:'已有账号，立即登录',
        account:'账号',
        accountExplain:'中英文均可，最长14个英文字符或汉字',
        name:'姓名',
        setPassword:'设置密码',
        passwordExplain:'密码建议使用字母、数字、符号两种以上组合，8-20个字符',
        affirmPassword:'确认密码',
        phoneNumber: '手机号码',
        validCode:'验证码',
        getCode:'获取验证码',
        resend:'重新发送',
        read:'我已阅读并同意长光卫星技术股份有限公司',
        read1:'用户注册协议',
        read2:'查看协议',
        read3:'和',
        read4:'隐私声明',
        read5:'查看隐私声明',
        info:'长光卫星技术股份有限公司门户网站账号为门户内各产品通用，您可用该账号登录门户下所有产品',
        regSuccess:'您的账号已注册成功',
        regSuccess1:'秒后将跳转至登录页面',
        LoginNow:'立即登录',
        rules1:'该项不能为空',
        rules2:'长度不能超过14个字符',
        rules3:'密码长度不能小于8',
        rules4:'密码长度不能超过20',
        rules5:'手机号格式有误',
        rules6:'密码中包含空格',
        rule7: '邮箱格式错误' ,
        rules8: '用户名已注册',
        rules9: '网络错误',
        rules10: '手机号已注册',
        rules11: '两次密码不一致',
        rules12: '密码强度不够',
        email: '电子邮箱',
        prefix: '区号',
    },
    changePassword:{
        accountSet:'账号设置',
        changePassword:'个人中心',
        haveSoCreate:'已有账号，立即登录',
        inputOldPasswd:'请输入原密码',
        inputNewPasswd:'请输入新密码',
        forgetPasswd:'忘记密码',
        passwordExplain:'密码建议使用字母、数字、符号两种以上组合，8-20个字符',
        sure:'确认',
        info:'长光卫星技术股份有限公司门户网站账号为门户内各产品通用，您可用该账号登录门户下所有产品',
        regSuccess:'您的密码已设置成功',
        regSuccess1:'秒后将跳转至登录页面',
        LoginNow:'立即登录',
        rules1:'该项不能为空',
        rules2:'长度不能超过14个字符',
        rules3:'密码长度不能小于8',
        rules4:'密码长度不能超过20',
        rules5:'手机号格式有误',
        rules6:'密码中包含空格',
    },
    forgetPassword:{
        accountSet:'账号设置',
        findPassword:'找回密码',
        haveSoCreate:'已有账号，立即登录',
        phoneNumber: '手机号码',
        findExplain:'若注册未绑定手机号，请联系',
        people:'人工客服',
        validCode:'验证码',
        getCode:'获取验证码',
        resend:'重新发送',
        setPassword:'设置密码',
        passwordExplain:'密码建议使用字母、数字、符号两种以上组合，8-20个字符',
        sure:'确认',
        info:'长光卫星技术股份有限公司门户网站账号为门户内各产品通用，您可用该账号登录门户下所有产品',
        regSuccess:'您的密码已设置成功',
        regSuccess1:'秒后将跳转至登录页面',
        LoginNow:'立即登录',
        callUs:'联系我们',
        market:'市场',
        phone:'电话',
        company:'长光卫星技术股份有限公司',
        close:'关闭',
        rules1:'该项不能为空',
        rules2:'长度不能超过14个字符',
        rules3:'密码长度不能小于8',
        rules4:'密码长度不能超过20',
        rules5:'手机号格式有误',
        rules6:'密码中包含空格',
        rules7:'手机号未注册',
        rules8:'手机号不能为空',
        rules9: '验证码或手机号错误',
    },
    homeFooter:{
        tel:'联系电话',
        email:'联系邮箱',
        advisoryService: '咨询客服',
        weChat:'“吉林一号”微信公众号',
        blog:'“长光卫星”微博',
        satelliteData:'卫星数据',
        advancedService:'高级服务',
        ecologicalZone :'生态专区',
        forum:'星空大本营',
        systems:'应用系统',

        startToExperience:'开始体验',
        archivedData:'存档数据服务',
        programmedPhotography:'编程摄影服务',
        yjs:'可视化与应用平台earth',
        sampleData:'样例数据中心',
        constellationPerformanceSimulation:'星座效能仿真服务',
        globalTargetLibrary:'吉林一号全球目标库',

        productsAndServices:'产品与服务',
        satelliteImage:'卫星影像',
        valueAddedProducts:'增值产品',
        applicationPlatform:'应用平台',
        toolSoftware:'工具软件',
        satelliteConstellationPage:'卫星星座',

        userSupport:'用户支持',
        resourceCenter:'资源中心',
        pricing:'定价规则',
        developers:'开发者支持',

        companyName:'长光卫星技术股份有限公司',
        ICP:'吉ICP备15001825号-1',
        address:'吉林省长春市北湖科技开发区明溪路1299号',


    },
    homeNavi:{
        title:"吉林一号生态开放商城",
        homePage:'首页',
        login:'登录',
        register:'注册',
        personalCenter:'个人中心',
        myOrder:'我的订单',
        logout:'退出登录',

        satelliteData:'卫星数据',
        advancedService:'高级服务',
        ecologicalZone :'生态专区',
        forum:'星空大本营',
        VIPBenefits:'会员权益',
        systems:'应用系统',


        startToExperience:'开始体验',
        productsAndServices:'产品与服务',
        userSupport:'用户支持',
        archivedDataOrder:'存档订购',
        programmedPhotography2:'编程摄影',
        aboutUs:"关于长光卫星",


        archivedData:'存档数据服务',
        programmedPhotography:'编程摄影服务',
        yjs:'可视化与应用平台earth',
        sampleData:'样例数据中心',
        constellationPerformanceSimulation:'星座效能仿真服务',
        constellationVisibilityAnalysis:'星座可见性分析',
        globalTargetLibrary:'吉林一号全球目标库',

        satelliteImage:'卫星影像',
        ordinaryOpticalImage:'普通光学影像',
        luminousImages:'夜光影像',
        multispectralImage:'多光谱影像',
        satelliteVideo:'卫星视频',
        threeDData:'立体数据',

        valueAddedProducts:'增值产品',
        remoteSensingData:'遥感数据集',
        onePicture:'一张图产品',
        urban:'城市类产品',
        agriculturalRemoteSensing:'农业遥感产品',
        forestryRemoteSensing:'林业遥感产品',
        waterConservancyRemoteSensing:'水利遥感产品',
        ecoEnvironmentalRemoteSensing:'生态环保遥感产品',

        applicationPlatform:'应用平台',
        dataAccessSystem:'吉林一号数据引接系统',
        visualizationPlatform:'三维可视化平台（云极视）',
        twoViolations:'“两违”整治遥感监管服务系统',
        agriculturalInsuranceServiceSystem:'农业保险遥感服务系统',
        skyAndGroundMonitoringSystem:'自然保护区天空地一体化监管系统',
        riverMasterInformationManagementSystem:'河长制信息管理系统',
        ecologicalProtectionRedLineSystem:'生态保护红线遥感应用系统',
        satelliteConstellationPlanningSystem:'遥感卫星星座规划系统',

        toolSoftware:'工具软件',
        fastProcessingAllInOneMachine:'遥感数据快速处理一体机',
        satellitePlanningSystem:'卫星规划系统',
        spectralImageProcessing:'光谱卫星图像处理套件',
        globalTargetLibrarySoftware:'吉林一号全球目标库软件',
        videoProcessing:'卫星视频处理套件',

        satelliteConstellationPage:'卫星星座',
        satelliteConstellationPage1:'吉林一号星座',
        resourceCenter:'资源中心',
        sampleData2:'样例数据',
        documentMaterial:'文档材料',
        toolSoftware2:'工具软件',
        ADailyChart:'每日一图专栏',

        pricing:'定价规则',
        pricing1: '数据定价',

        developers:'开发者支持',
        APIService:'API服务',

        developer: '开发者中心',

        chromeAlert:'为了您更好的使用体验，推荐使用Chrome浏览器访问本站点',
        chromeAlertDownload:'点击下载',
        chromeAlertClose:'关闭',



    },
    water:{
        title:'水利遥感应用',
        titleText:'随着经济的增长、人口的增加、环境的变化，水资源的问题逐渐突出。针对当前中国水资源现状，在传统调查、规划、管理技术的基础上引进遥感技术，加快信息的获取、更新，促进水利行业的发展。',
        acquiringSolutions:'获取解决方案',

        title2:'遥感大数据促进水利信息化建设',
        titleText2:'我国水资源开发利用形势的日益严峻，实施最严格的水资源管理及水利精细化管理对水利信息化提出了更高的要求。“吉林一号”海量遥感数据为防洪抗旱减灾、水资源合理配置、水生态环境保护、水利工程建设与管理和服务等水利业务发展提供了有力技术支撑和保障。',

        surfaceWaterResourceMonitoring:'地表水资源监测',
        surfaceWaterResourceMonitoringImgPs:'2018-2019年江苏省苏州市地表水资源提取',
        surfaceWaterResourceMonitoringText:'利用遥感数据光谱信息建立地表水体识别模型，结合深度学习算法解决地表河流提取不连续问题，为地表水资源调查和水生态环境监测提供数据支撑。',
        surfaceWaterResourceMonitoringItem1:'获取区域地表水面积及水域边界位置',
        surfaceWaterResourceMonitoringItem2:'多期动态监测获取水体变化信息',

        waterQualityMonitoring:'水质监测',
        waterQualityMonitoringImgPs:'2018-2019年江苏省苏州市水质监测',
        waterQualityMonitoringText:'通过“吉林一号”光谱星影像进行水体中叶绿素a、悬浮物等参数进行监测，并进行黑臭水体识别，可为城市水环境保护和水污染治理提供基础。',
        waterQualityMonitoringItem1:'估算大型湖泊、水库、河流、河口等区域水体的叶绿素a、悬浮物浓度',
        waterQualityMonitoringItem2:'获取城市黑臭水体分布情况',

        lakeShorelinesMonitoring:'河湖岸线遥感监测',
        lakeShorelinesMonitoringImgPs:'2015-2017年河口水库饮用水水源地周边生态监测',
        lakeShorelinesMonitoringText:'结合河段水环境功能定位，划定一定宽度的河湖滨岸带保护蓝线，通过“吉林一号”高分辨率遥感影像对生态蓝线范围内未经规划审批、未按规划审批方案建设、超过审批时限未拆除的已建或在建违法建筑物、构筑物进行监测，为违法建筑物拆除和整治工作提供依据。',
        lakeShorelinesMonitoringItem1:'提供河岸生态保护蓝线范围内的高级影像产品',
        lakeShorelinesMonitoringItem2:'河岸生态保护蓝线范围内违章建筑提取，提供违章建筑空间分布产品',
        lakeShorelinesMonitoringItem3:'提供违章建筑监测分析报告',

        floodDisasterMonitoring:'洪涝灾害监测',
        floodDisasterMonitoringImgPs:'2016年武汉特大洪水灾前灾后对比',
        floodDisasterMonitoringText:'基于洪水光谱特征与空间位置关系的分析，实现洪水淹没范围的快速提取。提供科学有效的洪涝灾害监测和评估结果，作为防灾减灾决策的重要依据，提高洪涝灾害决策与评估的时效性和精度。',
        floodDisasterMonitoringItem1:'灾区应急响应和灾情连续监测的高级影像产品',
        floodDisasterMonitoringItem2:'灾情信息提取和评价，快速提取淹没区域面积，识别准确度不低于80%',
        floodDisasterMonitoringItem3:'提供监测分析报告，根据灾情识别和动态分析结果',

        slogan:'“吉林一号”致力于为您提供更好用的遥感服务',


    },
    savedProduct:{
        title:'存档卫星影像',
        titleText:'“吉林一号”星座目前有31颗卫星在轨，是我国目前最大的商业遥感卫星星座，具备了较强的服务能力。“吉林一号”星座可对全球任意地点实现每天8~10次重访，具备全球一张图一年更新2次、全国一张图一年更新7次的能力，可为农林生产、环境监测、智慧城市、地理测绘、土地规划等各领域提供高质量的遥感信息和产品服务。',

        archivedImage:'海量存档数据',
        archivedImageText:'“吉林一号”星座共有31颗卫星在轨运行，均由长光卫星技术股份有限公司运营，可对全球任意位置单日访问最高10次，单日可观测目标超过200个，先后执行了两万多次拍摄任务，拍摄面积超过5000万平方公里，为10多个国家、100多家单位提供了多种类型的遥感信息服务。',
        archivedImageItem1:'多种成像模式',
        archivedImageItem1Ps:'普通光学、夜光、凝视视频、多光谱、立体、空间目标',
        archivedImageItem2:'多种空间分辨率',
        archivedImageItem3:'多种谱段组合',
        spectrum:'谱',

        sampleData:'样例数据',
        ordinaryOpticalImage:'普通光学影像',
        luminousImages:'夜光影像',
        satelliteVideo:'视频影像',
        multispectralImage:'多光谱影像',
        threeDData:'立体影像',
        SpaceTargetImaging:'空间目标成像',

        getMoreData:'获取更多数据',

        L1Product:'L1级产品指标',
        GXAImage:"光学A星推扫影像",
        SP03Video:"视频03星视频影像",
        SP0408Video:'视频04星-08星视频影像',
        SP0408Image:'视频04星-08星推扫影像',
        GPImage:'光谱星影像',
        GF03AImage:'高分03A星影像',
        GF02ABImage:'高分02A&高分02B推扫影像',
        KF01Image:'宽幅01星推扫影像',

        technicalIndicators:'技术指标',
        parameters:'参数',
        resolution:'星下点地面像元分辨率',
        spectralSegment:'光谱通道',
        quantizationBits:'量化位数',
        standardImageSize:'标准景大小(星下点)',
        trackHeight:'轨道高度',
        locationPrecision:'无控定位精度(CE90)',
        panchromatic:'全色',
        multispectral:'多光谱',
        fullColour:'全色',
        blue:'蓝色',
        green:'绿色',
        red:'红色',
        nearInfrared:'近红外',
        redEdge:'红边',
        multispectralSpectrum:'多光谱仪谱段',
        shortWaveInfraredSpectrum:'短波红外谱段',
        mediumWaveInfraredSpectrum:'中波红外谱段',
        longWaveInfraredSpectrum:'长波红外谱段',
        sixPointCameraMode:'6分相机模式，默认',
        threePointCameraMode:'3分相机模式',

        checkProductDescription:'查看完整版标准产品说明',



    },
    remoteSensing:{
        title:'遥感影像数据集',
        titleText1:'来自“吉林一号”星座获取的海量亚米级高分辨率光学遥感影像',
        titleText2:'包含十余个类别、上百万条数据，同时可根据客户需求进行定制化采集。',
        dataCubeText:'人工智能的飞速发展，数据驱动型AI时代的到来，数据缺失一直是限制模型研究的根本问题。遥感影像因其尺度多样性、视角特殊性、背景复杂度高等特点，对于遥感目标检测任务，需要专门的遥感影像数据集。吉林一号遥感影像数据集，由亚米级高分辨率光学遥感影像组成，包含十余个类别、上百万条数据，同时可根据客户需求进行定制化采集。',
        dataSetShow:'数据集展示',
        airport:'机场',
        port:'港口',
        tank:'油罐',
        miningArea:'矿区',
        ship:'船只',
        plane:'飞机',
        stadium:'体育场',
        powerStations:'发电站',
        customizeThematicDataset:'定制专题数据集',
        experienceImmediately:'立即体验',
        contactUs:'联系我们',
        market: '市场',
        phone: '电话',
        company: '长光卫星技术股份有限公司',
        close: '关闭',
    },
    material:{
        title:'下载中心',
        titleText:'长光卫星下载中心开放卫星数据产品资料、使用手册及使用工具，让使用过程简单、高效。',

        title2:'长光卫星下载中心',
        title2Text:'长光卫星下载中心为开发者、数据代理商、集成商开放卫星数据产品资料、使用手册及相关使用工具，对卫星产品标准等相关信息做了充分说明，让使用过程简单、高效。',


        download:'下载',
        checkDownload:'查看下载',

        noDataAboutSearch1:'找不到关于',
        noDataAboutSearch2:'的数据',

    },
    sampleData:{
        searchPlaceholder:'搜索',
        mostSearchKeyword:'热搜词',

        expand:'展开',
        collapse:'收起',

        scenario:'场景',
        processing:'处理',
        type:'类型',
        satellite:'卫星',
        resolution:'分辨率',

        dataList:'数据列表',
        parameters:'指标参数',
        dataNum1:'共',
        dataNum2:'个数据',

        download:'立即下载',
        dataSize:'数据量',
        dataUpdate:'更新于',
        noResult:'很抱歉，没找到您要的搜索结果',
        loadingData:'点击或下拉加载数据',
        loadingFinish:'到底啦',


        GXAImage:"光学A星推扫影像",
        SP03Video:"视频03星视频影像",
        SP0408Video:'视频04星-08星视频影像',
        SP0408Image:'视频04星-08星推扫影像',
        GPImage:'光谱01/02星推扫影像',
        GF03AImage:'高分03A星推扫影像',
        GF02ABImage:'高分02A/02B推扫影像',
        KF01Image:'宽幅01A星推扫影像',

        L1Product:'L1级产品指标',
        technicalIndicators:'技术指标',
        parameters2:'参数',
        resolution2:'星下点地面像元分辨率',
        spectralSegment:'光谱通道',
        quantizationBits:'量化位数',
        standardImageSize:'标准景大小(星下点)',
        trackHeight:'轨道高度',
        locationPrecision:'无控定位精度(CE90)',
        panchromatic:'全色',
        multispectral:'多光谱',
        fullColour:'全色',
        blue:'蓝色',
        green:'绿色',
        red:'红色',
        nearInfrared:'近红外',
        redEdge:'红边',
        multispectralSpectrum:'多光谱仪谱段',
        shortWaveInfraredSpectrum:'短波红外谱段',
        mediumWaveInfraredSpectrum:'中波红外谱段',
        longWaveInfraredSpectrum:'长波红外谱段',
        sixPointCameraMode:'6分相机模式，默认',
        threePointCameraMode:'3分相机模式',

        checkAllParameters:'点击查看完整版参数',

        close:'关闭',

    },

    common: {
        getSolution: '获取解决方案',
        ending: '“吉林一号”致力于为您提供更好用的遥感服务',
        contactUs: '联系我们',
        market: '市场:',
        tel: '电话:',
        us: '长光卫星技术股份有限公司',
        close: '关闭',
        goNow: '立即前往',
        buyNow: '立即购买',
        seeMore: '查看更多',
    },
    API: {
        judeDiv: '概述',
        title: '长光卫星服务API',
        title_: '长光卫星服务API',
        latestUpdateTime: '最后更新时间: 2019年08月19日',
        summary: '概述',
        summary1: '登录接口提供用户获取令牌（token）的功能，认证用户访问权限。所有的接口调用都需要提供用户登录后获取的 token，默\n' +
            '                    认通过登录接口获取 token 的默认有效时限为 7天， 如需持续可用的用户token，请联系长光卫星市场部获取。当调用服务接口\n' +
            '                    时，如果 token 过期或权限不足则会返回 700错误。该接口通过 HTTP 协议验证用户名、密码，验证成功后返回用户 token。',
        summary2: '根据用户指定的空间、时间、数据类型、数据指标等信息，查询长光卫星标准产品存档数据库，为用户返回满足条件的数据列表。',
        summary3: '返回指定条件下的存档数据统计信息。',
        summary4: '查询截止到目前的存档数据统计信息。',
        summary5: '用户通过该接口可以查询输入时间段内的卫星过境时间点',
        summary6: '用户可以通过该接口提交编程摄影的需求。',
        requestURL: '请求URL',
        requestMethod: '请求方式',
        requestField: '请求字段参数说明',
        requestFieldContinued: '请求字段参数续表',
        responseField: '响应字段说明',
        returnResultExample: '返回结果示例',
        introduction: '长光卫星服务API向开发者、长光卫星数据代理商、集成商提供HTTP接口， 以支持使用者以接口调用方式在线使用长光卫星标准产品接入服务。\n' +
            '          使用该服务前，使用者需实现联系长光卫星市场部申请API使用key，不同类型用户可以获取不同的数据接入与访问能力。',
        interfaceList: '接口列表',
        apiList1: '验证Key',
        apiList2: '覆盖面积查询接口',
        apiList3: '存档数据信息统计接口',
        apiList4: '编程摄影提交接口',
        apiList5: '需求状态获取接口',
        apiList6: '卫星过境查询接口',
        interfaceListItem1: '验证Key',
        interfaceListItem2: '覆盖面积查询接口',
        interfaceListItem3: '存档数据信息统计接口',
        interfaceListItem4: '编程摄影提交接口',
        interfaceListItem5: '需求状态获取接口',
        interfaceListItem6: '卫星过境查询接口',
        returnRule: '返回值规范',
        returnSample:
            '{\n' +
            '    "data": xxxxxxx,                            返回数据，详见各接口响应字段说明和返回接口示例\n' +
            '    "message": xxxxxxx,                     状态描述 ，详见2.4\n' +
            '    "status": xxxxxxx                           状态码，详见2.4\n' +
            '}',
        returnIllustrateList: '返回值说明',
        returnListHeaders1: '状态码',
        returnListHeaders2: '状态描述',
        returnListHeaders3: '包含错误描述',
        returnDescriptionListStatus00: '无',
        returnDescriptionListStatus1: 'success',
        returnDescriptionListStatus2: '服务器内部错误',
        returnDescriptionListStatus3: '传入的参数不合法',
        returnDescriptionListStatus4: '方法返回为空',
        returnDescriptionListStatus5: '添加失败',
        returnDescriptionListStatus6: '更新数据失败',
        returnDescriptionListStatus7: '删除数据失败',
        returnDescriptionListStatus8: '传入参数有误',
        returnDescriptionListStatus81: '参数格式错误或超过范围或输入错误',
        returnDescriptionListStatus9: '账户问题',
        returnDescriptionListStatus91: '无此用户，账号被冻结，密码错误，该用户已被注册',
        returnDescriptionListStatus10: 'token异常',
        returnDescriptionListStatus101: 'token过期或验证失败',
        itemsTitle1: '概述',
        itemsTitle2: '验证Key',
        items11: '存档查询API',
        items12: '标准数据缩略信息查询',
        items13: '覆盖面积查询接口',
        items14: '存档数据信息统计接口',
        items21: '编程摄影API',
        items22: '编程摄影提交接口',
        items31: '卫星可见性API',
        items32: '卫星过境查询接口',
        KeyrequestParamHeaders1: '名称',
        KeyrequestParamHeaders2: '描述',
        KeyrequestParamHeaders3: '类型',
        KeyrequestParamHeaders4: '是否必填',
        KeyrequestParamHeaders5: '备注',
        KeyrequestParamList1: '账号',
        KeyrequestParamList2: '密码',
        KeyresponseParamHeaders1: '序号',
        KeyresponseParamHeaders2: '名称',
        KeyresponseParamHeaders3: '描述',
        KeyresponseParamHeaders4: '类型',
        KeyresponseParamHeaders5: '备注',
        KeyresponseParamList41: '用户获取到的token',
        KeyresponseParamList42: '携带到之后的请求的header中，证明是否有权限访问资源',
        productInforequestParamHeaders1: '名称',
        productInforequestParamHeaders2: '描述',
        productInforequestParamHeaders3: '类型',
        productInforequestParamHeaders4: '是否必填',
        productInforequestParamHeaders5: '备注',
        productInforequestParamList11: '每页的大小',
        productInforequestParamList12: 'pageSize=0,pageNum=0表示不分页',
        productInforequestParamList21: '请求第几页',
        productInforequestParamList22: 'pageSize=0,pageNum=0表示不分页',
        productInforequestParamList31: '按照排序的字段',
        productInforequestParamList32: 'orderByField不为空;可选的排序字段包括imagingTime,imageGsd',
        productInforequestParamList41: '排序方式',
        productInforequestParamList42: 'order=asc升序,order=  desc降序orderByField为空，默认不排序',
        productInforequestParamList51: '产品类型',
        productInforequestParamList52: '单选，详情见下表',
        productInforequestParamList61: '数据谱段',
        productInforequestParamList62: '多选，详情见下表',
        productInforequestParamList71: '分辨率',
        productInforequestParamList72: '单选，详情见下表',
        productInforequestParamList81: '云量',
        productInforequestParamList82: '0-99可选，默认值为50，查询不高于该值的数据',
        productInforequestParamList91: '侧摆角',
        productInforequestParamList92: '0-45可选，默认值45，查询不高于该值的数据',
        productInforequestParamList101: '拍摄开始时间',
        productInforequestParamList102: '允许有一个时间为空',
        productInforequestParamList111: '拍摄结束时间',
        productInforequestParamList112: '允许有一个时间为空',
        productInforequestParamList121: '产品质量',
        productInforequestParamList122: '取值A，B，C，D，单选',
        productInforequestParamList131: '查询地区地理范围',
        productInforequestParamList132: 'geojson格式',
        productInforequestParamList1_11: '1:普通光学影像',
        productInforequestParamList1_12: 'JL101A-光学A星\n' +
            'JL104B-视频04星\n' +
            'JL105B-视频05星\n' +
            'JL106B-视频06星\n' +
            'JL107B-视频07星\n' +
            'JL108B-视频08星',
        productInforequestParamList1_21: '2:夜光影像',
        productInforequestParamList1_22: 'JL103B-视频03星\n' +
            'JL104B-视频04星\n' +
            'JL105B-视频05星\n' +
            'JL106B-视频06星\n' +
            'JL107B-视频07星\n' +
            'JL108B-视频08星',
        productInforequestParamList1_31: '3:视频影像',
        productInforequestParamList1_32: 'JL103B-视频03星\n' +
            'JL104B-视频04星\n' +
            'JL105B-视频05星\n' +
            'JL106B-视频06星\n' +
            'JL107B-视频07星\n' +
            'JL108B-视频08星',
        productInforequestParamList1_41: '4:多光谱影像',
        productInforequestParamList1_42: 'PMS\n' +
            'LWIR长波红外\n' +
            'MWIR中波红外\n' +
            'SWIR短波红外',
        productInforequestParamList1_43: 'JL101C-光谱01星\n' +
            'JL102C-光谱02星',
        productInforesponseParamList31: '数据列表',
        productInforesponseParamList311: '产品id',
        productInforesponseParamList312: '卫星',
        productInforesponseParamList313: '分辨率',
        productInforesponseParamList314: '拍摄时间',
        productInforesponseParamList315: '地理范围信息',
        productInforesponseParamList316: '谱段数',
        productInforesponseParamList317: '包含的谱段',
        productInforesponseParamList318: '云量',
        productInforesponseParamList319: '侧摆',
        productInforesponseParamList3110: '缩略图',
        productInforesponseParamList3111: '拇指图',
        productInforesponseParamList3112: '产品质量',
        productInforesponseParamList3113: '产品类型',
        productInforesponseParamList3114: '太阳高度角',
        productInforesponseParamList3115: '景中心经度',
        productInforesponseParamList3116: '景中心纬度',
        productInforesponseParamList3117: '传感器',
        productInforesponseParamList3118: '产品谱段',
        productInforesponseParamList32: '总条数',
        productInforesponseParamList33: '总页数',
        productInforesponseParamList34: '当前页数',
        productInforesponseParamList35: '每页显示数量',
        productInforesponseParamList36: '是否升序',
        productInforesponseParamList37: '排序字段',
        targetArearequestParamList11: '用于验证用户权限的字段',
        targetArearequestParamList12: 'Bearer + " " （空格）+ token',
        targetArearequestParamList21: '卫星id',
        targetArearequestParamList22: '可多选,详情如下表',
        targetArearequestParamList31: '产品类型',
        targetArearequestParamList32: '单选,详情如下表',
        targetArearequestParamList41: '数据谱段',
        targetArearequestParamList42: '可多选,详情如下表',
        targetArearequestParamList51: '分辨率',
        targetArearequestParamList52: '单选,详情如下表',
        targetArearequestParamList61: '云量',
        targetArearequestParamList62: '0-99可选，默认值为50，查询不高于该值的数据',
        targetArearequestParamList71: '侧摆角',
        targetArearequestParamList72: '0-45可选，默认值45，查询不高于该值的数据',
        targetArearequestParamList81: '拍摄开始时间',
        targetArearequestParamList82: '允许有一个时间为空',
        targetArearequestParamList91: '拍摄结束时间',
        targetArearequestParamList92: '允许有一个时间为空',
        targetArearequestParamList101: '产品质量',
        targetArearequestParamList102: '取值A，B，C，D，单选',
        targetArearequestParamList111: '查询地区地理范围',
        targetArearequestParamList112: 'geojson格式',
        targetArearesponseParamList31: '当前区域存档数据（景）',
        targetArearesponseParamList32: '当前区域拍摄面积汇总（平方公里）',
        targetArearesponseParamList33: '当前区域覆盖面积（平方公里）',
        targetArearesponseParamList34: '区域内产品存档数据（景）',
        targetArearesponseParamList35: '区域内产品拍摄面积汇总（平方公里）',
        targetArearesponseParamList36: '区域内产品覆盖面积（平方公里）',
        targetArearesponseParamList37: '当前区域覆盖geo',
        targetArearesponseParamList38: '覆盖区域百分比',
        ArchiverequestParamList1: '用于验证用户权限的字段',
        ArchiverequestParamList2: 'Bearer + " " （空格）+ token',
        ArchiveresponseParamList31: '存档数据（景）',
        ArchiveresponseParamList32: '拍摄面积汇总（平方公里）',
        ArchiveresponseParamList33: '覆盖面积（平方公里）',
        ArchiveresponseParamList34: '覆盖面积（平方公里）',
        transitrequestParamList1: '经度',
        transitrequestParamList2: '纬度',
        transitrequestParamList31: '卫星id',
        transitrequestParamList32: '例如JL101A',
        transitrequestParamList4: '开始时间',
        transitrequestParamList5: '结束时间',
        transitresponseParamList31: '侧摆',
        transitresponseParamList32: '过境时间',
        transitresponseParamList33: '过境时间',
        transitresponseParamList34: '太阳高度角',
        ProgrammingrequestParamList1: '客户id',
        ProgrammingrequestParamList2: '客户名字',
        ProgrammingrequestParamList3: '云量',
        ProgrammingrequestParamList41: '交付时间',
        ProgrammingrequestParamList42: '成像24、48、72小时',
        ProgrammingrequestParamList51: '几何要求',
        ProgrammingrequestParamList52: '0：没有要求 1：≤200m 2：≤100m',
        ProgrammingrequestParamList5: '成像时长',
        ProgrammingrequestParamList6: '地理范围',
        ProgrammingrequestParamList71: '成像模式',
        ProgrammingrequestParamList72: '1：推扫成像 2：凝视成像 3：夜光成像 4：立体成像',
        ProgrammingrequestParamList8: '结束拍摄时间',
        ProgrammingrequestParamList91: '频次要求',
        ProgrammingrequestParamList92: '1：按次数 2：按频率',
        ProgrammingrequestParamList10: '拍摄时间间隔',
        ProgrammingrequestParamList11: '拍摄卫星',
        ProgrammingrequestParamList12: '开始拍摄时间',
        ProgrammingrequestParamList131: '是否多宫格拍摄',
        ProgrammingrequestParamList132: '0：否 1：是',
        ProgrammingrequestParamList141: '是否敏感',
        ProgrammingrequestParamList142: '0：否 1：是',
        ProgrammingrequestParamList15: '优先级',
        ProgrammingrequestParamList16: '产品类型',
        ProgrammingrequestParamList171: '辐射要求',
        ProgrammingrequestParamList172: '0：没有要求 1：无明显辐射',
        ProgrammingrequestParamList18: '需求名字',
        ProgrammingrequestParamList191: '需求类型',
        ProgrammingrequestParamList192: '0:点目标 1:区域目标',
        ProgrammingrequestParamList20: '备注',
        ProgrammingrequestParamList21: '分辨率',
        ProgrammingrequestParamList22: '拍摄次数',
        ProgrammingrequestParamList23: '侧摆角',
        ProgrammingrequestParamList241: '谱段要求',
        ProgrammingrequestParamList242: '0：没有要求 1：三谱段 2：四谱段',
        ProgrammingsponseParamList4: '订单ID',
    },
    agriculture: {
        title: '农业遥感应用',
        subTitle: '农田作物信息的快速获取与解析是开展精准农业实践的前提和基础，“吉林一号”数据客观、准确、及时地提供作物的生态环境和作物生长的各种信息，为农业生产和实践提供支持。',
        getSolution: '获取解决方案',
        title2: '多谱段、大幅宽数据服务农业发展',
        subTitle2: '面向农业生产管理的需求，结合“吉林一号”提供的“红边”、短波、中波、长波红外波段，快速获取地表农业数据信息，实现了对农业种植结构、农作物长势、农业病虫害等精准的监测，形成了农业调查统计、农业生产管理、农作物估产、病虫害防治、农业保险等整套解决方案。',
        plantingStructureMonitoring: '种植结构监测',
        plantingStructureSubtitle: '利用遥感数据的可见光、近红外和短波红外波段，辅以土地利用现状数据、地面调查数据、农业历史统计数据，通过分析各类农作物在不同物候期的光谱特征、纹理特征，建立农作物种植结构提取模型。',
        plantingStructureService11: '提取区域单一或多种作物的空间分布和种植面积',
        plantingStructureService12: '',
        plantingStructureService21: '利用时间序列和深度学习算法进行遥感种植结构专题产品生产分类',
        plantingStructureService22: '',
        plantingStructureService2Subtitle: '精度高于同类产品',
        plantingStructureImgTitle: '2017年新疆石河子农八师农作物种植结构分布',
        cropGrowthMonitoring: '作物长势监测',
        cropGrowthMonitoringSubtitle: '根据“吉林一号”大幅宽、多谱段、多分辨率、高时效性的卫星影像，在整个作物生长期内进行近实时监测，结合遥感影像资料及作物物候期信息提供长势监测产品，在作物收获期前提供农作物生长曲线，反映农作物生长状况信息。',
        cropGrowthMonitoringImgTitle: '2019年埃及南部达克拉地区作物长势',
        cropGrowthMonitoringService1: '宏观监测区域农作物长势情况',
        cropGrowthMonitoringService21: '与历史同期对比，宏观比较监测区域长势',
        cropGrowthMonitoringService22: '',
        droughtAssessment: '旱情评估',
        droughtAssessmentSubtitle: '结合“吉林一号”卫星数据，通过对地面温度和作物生理参数等数据进行建模，建立评估土壤水分含量变化状况的干旱监测模型，以快速、客观、大范围的特点，实现土壤墒情以及旱情监测。',
        droughtAssessmentService1: '提供表层土壤水分含量，空间分布',
        droughtAssessmentService21: '对农田区域进行旱情等级评价，提供不同干旱等级空间分布和面积',
        droughtAssessmentService22: '',
        droughtAssessmentImgTitle: '2017-2018年吉林省农安县旱情监测',
        floodMonitoring: '涝灾监测',
        floodMonitoringSubtitle: '利用农作物识别模型、水体提取模型和深度学习算法，结合作物受灾之后波谱特征的变化进行农作物受灾面积识别和灾害等级评价，指导防灾减灾工作的开展，辅助灾害影响评估，提供不同尺度的高频次遥感监测产品。',
        floodMonitoringService11: '通过星座联合规划快速提供多种空间分辨率、光谱分辨率数据',
        floodMonitoringService12: '',
        floodMonitoringService2: '对区域受灾程度和空间范围进行统计',
        floodMonitoringImgTitle: '2018年黑龙江五常洪涝灾害监测',
    },
    baseMap: {
        title: '2019年“吉林一号”全国5m光谱一张图',
        title_: '',
        subtitle: '2019年全国最新、最完整的卫星影像一张图，对应丰富光谱信息L1数据，空间分辨率5m真彩色影像，9.29日全国所有省会所在地级市开放数据免费下载通道',
        onePicture: '2019年最新全国5m分辨率一张图',
        onePictureSubtitle: '2019年全国最新、最完整的卫星影像一张图，对应丰富光谱信息L1数据，空间分辨率5m真彩色影像，所有数据均由吉林一号光谱01、02星获取，该型号卫星搭载了多光谱成像仪，短波、中波、长波红外相机，具有星上智能处理系统，可获取5米分辨率、110千米幅宽、26谱段的遥感数据。',
        timePhase: '时相',
        timePhaseContent: '2019年3月-2019年8月',
        resolutionRatio: '分辨率',
        resolutionRatioContent: '5米',
        spectrumBand: '谱段',
        spectrumBandContent1: '红630~680 nm',
        spectrumBandContent2: '绿525~600 nm',
        spectrumBandContent3: '蓝450~515 nm',
        cloud: '云量：<20% ',
        storage: '存储方式：各省按1：25w标准分幅标准分幅存储（港澳台按区域存储）',
        coordinateSystem: '坐标系：WGS-84',
        interSpectral: '谱间配准精度：优于1个像素',
        onlineBrowsingAndDownloading: '在线浏览与下载',
        onlineExperienceBtn: '在线体验',
        onlineBottom: 'GS(2019)1719号 - 甲测资字1100471',
        L1ProductIndex: 'L1级产品指标',
        technicalIndicators: '技术指标',
        params: '参数',
        groundPixelResolution: '星下点地面像元分辨率',
        groundPixelResolutionContent1: '(a)多光谱仪谱段:',
        groundPixelResolutionContent2: 'B0-B6分辨率为5m/B7-B12分辨率为10m/B13-B19分辨率为20m',
        groundPixelResolutionContent3: '(b) 短波红外谱段：',
        groundPixelResolutionContent4: 'SW1-SW4分辨率为100m',
        groundPixelResolutionContent5: '(c)中波红外谱段：',
        groundPixelResolutionContent6: 'MW1（100m）',
        groundPixelResolutionContent7: '(d)长波红外谱段:',
        groundPixelResolutionContent8: 'LW1（150m）',
        spectralChannel: '光谱通道',
        spectralChannelContent1: '(a)多光谱仪谱段:',
        spectralChannelContent2: '(b)短波红外谱段：',
        spectralChannelContent3: '(c)中波红外谱段：',
        spectralChannelContent4: '(d)长波红外谱段：',
        quantizationBits: '量化位数',
        standardLandscapeSize: '标准景大小(星下点)',
        trackHeight: '轨道高度',
        positioningAccuracy: '无控定位精度(CE90)',
        multichannelSpectrometer: '多光谱仪',
        checkFullBtn: '查看完整版标准产品说明',
        specialProductItems1:'吉林省吉林市桦甸市树种分类',
        specialProductItems2:'山东平邑大蒜种植面积调查',
        specialProductItems3:'西藏日喀则地表覆盖',
    },
    city: {
        title: '智慧城市应用',
        subtitle: '随着国家治理体系和治理能力现代化的不断推进，“智慧城市”的建设对空间信息提出更高的要求，遥感大数据是监测城市变化、实时管理城市的创新探索，是提升现代城市综合竞争力和国际影响力的必然选择。',
        title2: '遥感+AI助力智慧城市建设',
        subtitle2: '“5G”、“云计算”、“互联网+”等新兴技术的兴起与发展，为遥感大数据服务“智慧城市”提供了更多的落地应用场景。以“吉林一号”高分辨率影像为基础，综合城市宏观全貌和微观图像，提取城市土地利用、环境监测等数据，搭建城市地理信息综合服务平台，为加强城市统一管理提供解决方案。',
        buildingChangeDetection: '建筑变化检测',
        buildingChangeDetectionSubtitle: '结合“吉林一号”星座高分辨率卫星影像，获取城市用地变化情况，提供每月两次的矢量图斑产品，用于建筑工程监管，为执法部门查处违建、偷建、抢建等建筑工程及监管大型工程建设进展提供信息支撑，提高执法效率，提升执法公信度。',
        buildingChangeDetectionImgTitle: '2018年长春市北湖区建筑变化检测',
        buildingChangeDetectionService1: '重大工程进度持续监测',
        buildingChangeDetectionService2: '建筑变化位置、面积、类型等信息提取',
        buildingChangeDetectionService3: '违章建筑检测与识别',
        urbanLandResourcesSurvey: '城市土地资源调查',
        urbanLandResourcesSurveySubtitle: '土地资源调查是城市发展规划制定的基础数据，通过可见光、近红外数据，获取城市用地现状及城市植被覆盖度等数据，帮助城市管理部门查清家底，更合理地制定发展方案。',
        urbanLandResourcesSurveyService1: '多尺度土地利用现状监测',
        urbanLandResourcesSurveyService2: '各类型土地分布情况及面积',
        urbanLandResourcesSurveyImgTitle: '2019年天津市土地资源调查',
        urbanExpansionEvolution: '城市扩张演变监测',
        urbanExpansionEvolutionSubtitle: '通过长时间序列的遥感数据，获取城市历史演变情况，提供每年一次的栅格图及矢量图斑产品，用于城市管理部门，辅以划定城市发展边界，防治城市用地无序蔓延，实现土地可持续利用。',
        urbanExpansionEvolutionService11: '掌握城市演变规律，划定城市发展边界，防治城市用地无序蔓延',
        urbanExpansionEvolutionService12: '',
        urbanExpansionEvolutionService21: '指导城市规划，提高城市土地利用效率，实现土地可持续利用',
        urbanExpansionEvolutionService22: '',
        urbanExpansionEvolutionImgTitle: '1990-2016年长春市城市扩张监测',
        urbanEcologicalEnvironment: '城市生态环境质量评价',
        urbanEcologicalEnvironmentSubtitle: '应用高分辨率影像，提取地物信息，采用监督分类和决策树方法提取影响环境质量的各种因子，最终得到环境质量的综合评价，为城市区域合理性规划和保护提供基础。',
        urbanEcologicalEnvironmentService11: '按规范评价的标准和方式，对城市内生态环境的质量现状评价',
        urbanEcologicalEnvironmentService12: '',
        urbanEcologicalEnvironmentService21: '评估长时间序列生态环境质量变化，找出环境质量改变的原因',
        urbanEcologicalEnvironmentService22: '',
        urbanEcologicalEnvironmentImgTitle: '1990-2016年长春市城市生态环境质量评价',
    },
    dataSetInfo: {
        airport: '机场目标',
        harbour: '港口目标',
        nearby: '附近',
        exploreMore: '探索更多',
        viewLarge: 'View large',
        imgName: '北京首都国际机场T2航站楼',
        imgLoction: '北京市朝阳区',
        search: '请输入感兴趣的地点或经纬度',
        seeImage: '查看大图',
    },
    forestry: {
        title: '自然资源监测',
        subtitle: '围绕自然资源调查、监测、评价、决策全过程，“吉林一号”通过定期监控和快速更新，实现从周期性调查到动态化监测的转型升级，为山水林田湖草自然资源调查监测提供技术保障。',
        title2: '海量遥感数据提升自然资源调查监管能力',
        subtitle2: '“吉林一号”丰富的遥感卫星影像数据源为地球上自然资源动态变化信息提供数据支持。面向自然资源调查、监测、评价、决策的需求，提供林草资源“一张图”、植被覆盖度、湿地类型分类、森林火灾监测、森林病虫害监测、生态评估等综合解决方案。',
        forestResourcesSurvey: '森林资源调查',
        forestResourcesSurveyImgTitle: '2017年吉林市森林资源调查',
        forestResourcesSurveySubtitle: '利用多源多时相遥感数据、地形数据、森林物候特征数据等基础数据，采用人工神经网络、决策树模型、支持向量机等监督和非监督分类方法，提取遥感影像中的土地利用类型、森林类型以及多时相影像间的森林类型变化信息。',
        forestResourcesSurveyService11: '提取区域单一或多种树种林地类型的空间分布与面积统计',
        forestResourcesSurveyService12: '',
        forestResourcesSurveyService2: '为森林资源现状和变更调查提供服务',
        wetlandExtraction: '湿地类型提取',
        wetlandExtractionImgTitle: '2018年查干湖国家级自然保护区及外围保护带湿地类型分析',
        wetlandExtractionService11: '提取区域单一或多种湿地类型的空间分布与面积统计',
        wetlandExtractionService12: '',
        wetlandExtractionService2: '分类精度优于85%',
        wetlandExtractionSubtitle: '应用“吉林一号”多时相、多波段的观测数据，采用面向对象方法，充分考虑地物的光谱特征和空间特征，完成湿地资源类型提取。',
        naturalReserveMonitoring: '自然保护区监测',
        naturalReserveMonitoringSubtitle: '针对自然保护区内人类活动进行多尺度分割，建立分类规则集，提取保护区内各人类活动信息，对比前后不同时相的影像，分析人类活动动态变化情况。',
        naturalReserveMonitoringService11: '获取自然保护区内违法砍伐、放牧、狩猎、捕捞、采药、开垦、',
        naturalReserveMonitoringService12: '烧荒、开矿、采石、挖沙、影视拍摄以及其他法律法规禁止的活',
        naturalReserveMonitoringService13: '动的分布情况',
        naturalReserveMonitoringService14: '',
        naturalReserveMonitoringService21: '通过多期分析自然保护区内道路修建、建设项目进展',
        naturalReserveMonitoringService22: '',
        naturalReserveMonitoringImgTitle: '自然保护区遥感信息服务平台',
        fireMonitoring: '火灾监测',
        fireMonitoringSubtitle: '森林火灾防控与预警是森林资源保护的重要业务。利用“吉林一号”卫星宽覆盖、高重访的特点，基于森林火点在遥感影像短波红外、热红外波段的光谱特征，快速识别森林火点，为森林火灾防控与预警业务提供支持。',
        fireMonitoringService11: '应急监测，快速识别火点，提供森林火点位置分布、面积',
        fireMonitoringService12: '',
        fireMonitoringService21: '利用星上AI火点识别和卫星高频次重访，识别并预警',
        fireMonitoringService22: '',
        fireMonitoringService3: '火点提取准确率优于90%',
        fireMonitoringImgTitle: '2019年巴西大火监测',
    },
    home: {
        contact1: '咨',
        contact2: '询',
        cardTitle1: '存档订购',
        card1Subtitle: '海量高分辨率影像查询订购',
        cardTitle2: '编程摄影',
        card2Subtitle: '快速响应的按需定制化拍摄',
        cardTitle3: '在线应用',
        card3Subtitle: '遥感信息一站式综合服务引擎',
        cardTitle4: '数据集',
        card4Subtitle: '十余个类别、上百万条数据',

        card1sSubtitle: '影像查询订购',
        card2sSubtitle: '按需定制拍摄',
        cardTitle3s: '样例中心',
        card3sSubtitle: '免费样例下载',
        card4sSubtitle: '海量分类数据',

        industryTitle: '行业应用',
        industrySubTitle: '“吉林一号”卫星遥感影像已广泛应用于国土资源监测、土地测绘、矿产资源开发、智慧城市建设、交通设施监测、农业估产、林业资源普查、生态环境监测、防灾减灾及应急响应等领域。',

        title: '产品与服务',
        subtitle: '用空天地一体化遥感信息产品服务全球70亿人',
        satelliteImg: '卫星影像',
        valueAddedProducts: '增值产品',
        applicationPlatform: '应用平台',
        tools: '工具软件',
        archivedData: '存档数据',
        archivedDataSubtitle: '“吉林一号”全球海量高分辨率影像查询订购，涵盖光学、视频、夜光、多光谱、立体多个类型',
        programming: '编程摄影',
        programmingPhotographySubtitle: '地面编程控制“吉林一号”卫星按用户指定成像时间和位置定制化拍摄，最快24小时可交付数据',
        sampleData: '样例数据',
        sampleDataSubtitle: '提供"吉林一号"多种类型遥感数据,注册登录即可免费下载，样例数据定期更新',
        normalOpticalImage: '普通光学影像',
        normalOpticalImageSubtitle: '“吉林一号”普通光学影像包括0.72m、0.75m、0.92m及1m多种分辨率，包含蓝色、绿色、红色、红边及近红外波段',
        luminousImage: '夜光影像',
        luminousImageSubtitle: '“吉林一号”夜光影像是目前全球唯一可公开获取的亚米级真彩色夜光遥感数据产品，影像可反映地面灯光的真实色彩和强度',
        video: '视频影像',
        videoSubtitle: '“吉林一号”视频单帧影像分辨率高达12K*5K,存储大小175M,经过传感器校正及稳像处理得到彩色动态视频产品',
        multispectralImage: '多光谱影像',
        multispectralImageSubtitle: '“吉林一号”多光谱影像为5米分辨率、110千米幅宽，涵盖450nm—13500nm共26个谱段，能够实现理论上14天一次的高频次更新',
        DEMDSMImage: 'DEM/DSM影像',
        DEMDSMImageSubtitle: '实现地表三维重建，获取高精度数字表面模型和数字高程模型，准确的反映地表特征的细节信息和高程信息',
        remoteSensingDataSet: '遥感数据集',
        remoteSensingDataSetSubtitle: '来自“吉林一号”获取的海量遥感影像，包含十余个类别、上百万条数据，可根据客户需求进行定制化采集',
        onePictureOfChina: '全国一张图',
        onePictureOfChinaSubtitle: '以“吉林一号”5m分辨率多光谱数据为基础数据源，包含遥感影像一张图以及地表覆盖分类一张图',
        urbanRemoteSensingProducts: '城市遥感产品',
        urbanRemoteSensingProductsSubtitle: '建筑变化检测、城市土地资源调查、固体废弃物监测、城市生态环境质量评价、城市扩张演变监测',
        agriculturalRemoteSensingProducts: '农业遥感产品',
        agriculturalRemoteSensingProductsSubtitle: '种植结构检测、作物长势监测遥感、农作物旱情遥感监测产品、农作物洪涝灾害受损评估遥感',
        forestryRemoteSensingProducts: '林业遥感产品',
        forestryRemoteSensingProductsSubtitle: '优势树种遥感识别、森林火灾遥感监测、自然保护区人类活动遥感监测、枯死变色立木遥感监测',
        WaterRemoteSensingProducts: '水利遥感产品',
        WaterRemoteSensingProductsSubtitle: '地表水资源监测、水质监测、河湖岸线遥感监测、洪涝灾害监测、河湖“四乱”监测',
        ecoEnvironmentalRemoteSensingProducts: '生态环保遥感产品',
        ecoEnvironmentalRemoteSensingProductsSubtitle: '秸秆焚烧监测、生态环境评价、热岛监测',
        access: '吉林一号数据引接系统',
        accessPlatform: '为各类数据代理商、数据集成商、数据应用产品提供便捷、实时、高效、完整的“吉林一号”卫星数据接入服务',
        visualizationPlatform: '三维可视化平台',
        visualizationPlatformSubtitle: '集浏览、管理、处理及应用为一体的的全类型遥感信息一站式综合服务引擎，“吉林一号”卫星数据统一交付平台。',
        remoteSensingSupervisionServiceSystem: '“两违”整治遥感监管服务系统',
        remoteSensingSupervisionServiceSystemSubtitle: '以“吉林一号”为数据保障，实现对违法建筑与违法图斑上传、核查、分类处置、下发、整改的全流程管理',
        agriculturalInsurance: '农业保险遥感服务系统',
        agriculturalInsuranceSubtitle: '深度融合卫星、无人机等遥感数据与农业保险业务数据，解决“精确承保”、“快速理赔”等问题',
        skyGroundIntegrated: '自然保护区天空地一体化监管系统',
        skyGroundIntegratedSubtitle: '实现自然保护区监测管理工作网络化、数字化、智慧化，对自然保护区进行空天地一体化的监测',
        riverChief: '河长制信息管理系统',
        riverChiefSubtitle: '以卫星遥感和卫星定位技术为基础，及时发现城市河流湖泊资源数量、质量、结构的变化',
        EcologicalProtectionRedLine: '生态保护红线遥感应用系统',
        EcologicalProtectionRedLineSubtitle: '及时发现破坏生态保护红线的行为，全面掌握红线区生态系统构成、分布与动态变化',
        satelliteConstellationPlanningSystem: '遥感卫星星座规划系统',
        satelliteConstellationPlanningSystemSubtitle: '为用户需求生成对应任务的可见窗口和地面数传窗口，生成卫星成像计划、卫星指令以及地面站接收计划',
        fastProcessingMachine: '遥感数据快速处理一体机',
        fastProcessingMachineSubtitle: '快速完成数据解调后的原始数据解密解压缩、几何和辐射校正等一系列的标准化处理，生成标准影像产品',
        satellitePlanningSystem: '卫星规划系统',
        satellitePlanningSystemSubtitle: '为用户需求生成对应任务的可见窗口和地面数传窗口，生成卫星成像计划、卫星指令以及地面站接收计划',
        imageProcessingKit: '光谱卫星图像处理套件',
        imageProcessingKitSubtitle: '基于吉林一号卫星多光谱数据进行增值信息产品处理与生产，并提供数据及成果可视化与交互',
        dataAccessSystem: '吉林一号数据引接系统',
        dataAccessSystemSubtitle: '为各类数据代理商、数据集成商、数据应用产品提供便捷、实时、高效、完整的“吉林一号”卫星数据接入服务',
        satelliteTitle: '“吉林一号”星座',
        satelliteTitleSubtitle: '“吉林一号”卫星星座在轨16颗卫星，是我国目前最大的商业遥感卫星星座。“吉林一号”星座对全球任意地点的天重访能力达到4-7次，最快可在11分钟内实现对应急任务的响应。',
        opticalA: '光学A星',
        video0102: '视频01/02星',
        lingQiao: '灵巧验证星',
        video03: '视频03星',
        video0408: '视频04-08星',
        guangPu0102: '光谱01/02星',
        gaoFen03A: '高分03A星',
        gaoFen02A: '高分02A星',
        gaoFen02B: '高分02B星',
        kuanFu: '宽幅01星',
        dataCoverage: '数据覆盖范围',
        dataCoverageSubtitle: '“吉林一号”星座已有16颗卫星在轨运行，对全球任意地点的单日重访达到4-7次',
        cooperativePartner: '合作伙伴',
        cooperativePartnerSubtitle: '汇聚优秀伙伴，共建遥感生态，为用户创造价值',
        bottom: '观你所想，购你所需，尽在遥感易购',
        bottomSubtitle: '立即注册',
    },
    userBasicInfo:{
        img: '默认头像',
        info: '基本信息',
        account: '账号名',
        name: '真实姓名',
        change: '修改',
        save: '保存',
        phone: '手机号码',
        email: '电子邮箱',
        password: '密码',
        company: '公司名称',
        industry: '行业领域',
        position: '职位',
        location: '所在地区',
        vipLevel: '会员等级',
        vipPoint: '会员积分',
        close: '关闭',
        alert: '信息修改成功',
        alert1: '信息修改失败',
        alert2: '真实姓名不能为空',
        alert3: '邮箱格式不正确',
        alert4: '公司名称不能为空',
        alert5: '行业领域不能为空',
        alert6: '职位不能为空',
    },
    myOrder: {
        loading: '正在加载中',
        close: '关闭',
        myOrder: '我的订单',
        all: '全部',
        ToBePaid: '审核中',
        ongoing: '生产中',
        done: '已交付',
        refused: '已驳回',
        cancel: '已取消',
        notEvaluate:'待评价',
        aleadyEvaluate:'已评价',
        orderNum: '请输入订单号',
        requestName:'请输入需求名称',
        endTime: '结束时间',
        startTime: '起始时间',
        orderNum1: '订单号',
        requestName1: '需求名称',
        orderType: '订单类型',
        archivedData: '存档数据',
        tasking: '编程摄影',
        createTime: '创建时间',
        productType: '产品类型',
        general: '普通光学',
        luminous: '夜光',
        video: '视频',
        multispectral: '多光谱',
        payTime: '支付时间',
        status: '状态',
        money: '金额',
        operator: '操作',
        download: '下载',
        detail: '详情',
        evaluate:'评价',
        seeEvaluate:'查看评价',
        pay: '支付',
        noData: '暂无数据',

    },
    personalCenterList: {
        close: '关闭',
        personalCenter: '个人中心',
        info: '基本信息',
        myOrder: '我的订单',
        offersAndDiscounts: '优惠与折扣',
        coupons: '优惠券',
        memberSystem: '会员体系',
        contractAndInvoice: '合同与发票',
        contractManagement: '合同管理',
        invoiceManagement: '发票管理',
        noOpen: '暂未开放~~',
    },
    changePhone: {
        account: '账号设置',
        changePhone: '修改绑定手机号',
        sureUser: '为确认是您本人操作，请完成以下验证',
        oldPhone: '原手机号码',
        code: '验证码',
        getCode: '获取验证码',
        resend:'重新发送',
        nextStep: '下一步',
        info: '长光卫星技术股份有限公司门户网站账号为门户内各产品通用，您可用该账号登录门户下所有产品',
        NewPhone: '新手机号码',
        prefix: '区号',
        sure: '确认',
        success: '您的手机号码已修改成功',
        back: '返回个人中心',
        rule: '该项不能为空',
        rule1: '手机号格式有误',
        rules2: '不能原手机号码相同',
        rules3: '手机号需为数字',
        phoneCodeMessage: '验证码错误',
        newPhoneCodeMessage: '手机号格式错误',
        newPhoneCodeMessage1: '手机号不能为空',
        newPhoneCodeMessage2: '手机号或验证码错误',
    },

    invoiceManagement:{
        loading:'正在加载中',
        invoiceManagement:'发票管理',
        invoiceManagementPs1:'开票仅针对已消费金额，优惠券等抵扣金额不能开具发票',
        invoiceManagementPs2:'发票会在订单完成后3-4个工作日寄出，请耐心等待',
        invoiceInformation:'发票信息',
        manageInvoiceInformation:'管理发票信息',
        defaultTitle:'默认抬头',
        invoiceType:'发票类型',
        noInvoiceDefaultInformation:'暂无发票默认信息',
        deliveryAddress:'收件地址',
        manageDeliveryAddress:'管理收件地址',
        defaultRecipient:'默认收件人',
        noDefaultDeliveryAddress:'暂无默认收件地址',

        invoiceRecords:'开票记录',
        searchInvoiceRecords_orderNumber:'请输入订单号',
        searchInvoiceRecords_startTime:'起始时间',
        searchInvoiceRecords_endTime:'结束时间',

        applyTime:'申请时间',
        invoiceMedium:'发票介质',
        invoiceAmount:'发票金额',
        invoiceStatus:'状态',
        invoiceStatus_all:'全部',
        invoiceStatus_completed:'已开票',
        invoiceStatus_uncompleted:'待开票',
        invoiceOperation:'操作',
        preview:'预览',
        detail:'详情',
        noInvoiceRecords:'暂无数据',

    },
    invoiceInfoManagement:{
        loading:'正在加载中',
        close:'关闭',

        title: '请您与贵企业财务人员核实，确保提供的发票信息与在税务机关预留的登记信息保持一致，以免影响发票的后续使用。',
        type: '发票类型',
        comInvoice: '增值税普通发票',
        specialInvoice: '增值税专用发票',
        companyName: '单位名称',
        enterCompany: '请输入单位名称',
        code: '纳税人识别号',
        enterCode: '请输入纳税人识别号',
        companyAdress: '单位地址',
        enterAdress: '请输入单位地址',
        phone: '单位电话',
        enterPhone: '请输入单位电话',
        bank: '开户银行',
        enterBank: '请输入开户银行',
        bankAccount: '银行账号',
        enterBankAccount: '请输入银行账号',
        isDefaultInvoice: '设为默认抬头',
        sure: '确认',

        deleteText:'您确定要删除该发票信息吗？',
        deleteOk:'删除',
        cancel:'取消',

        invoiceManagement:'发票管理',
        invoiceInfoManagement:'发票信息管理',
        invoiceInfoManagementPs1:'增值税发票仅面向中国大陆客户，港澳台及海外企业客户无法开具此类发票',
        invoiceInfoManagementPs2:'可以创建增值税普通发票模板或增值税专用发票模板',
        invoiceInfoManagementPs3:'创建增值税普通发票模板及增值税专用发票时，发票抬头可以手动设置，支持修改',
        invoiceInfoManagementPs4:'支持创建多个收货地址模版，支持修改',
        invoiceInfoManagementPs5:'不支持退票和再次开具发票，请在提交订单时谨慎填写发票和地址信息，一旦提交订单，不支持修改发票和地址信息',
        more:'了解更多',
        collapse:'收起',

        invoiceInfo:'发票信息',
        addInvoiceInfo:'新增发票信息',
        invoiceTitle:'发票抬头',
        invoiceCode:'纳税人识别号',
        invoiceType:'发票类型',
        operation:'操作',

        setToDefault:'设为默认',
        defaultTitle:'默认抬头',
        modify:'修改',
        delete:'删除',
        noInvoiceInfo1:'暂无可用发票模版，请先',
        noInvoiceInfo2:'新增发票信息',

    },
    recipientInfoManagement:{
        loading:'正在加载中',
        close:'关闭',

        recipientName: '收件人姓名',
        enterName: '请输入收件人姓名',
        recipientPhone: '收件人手机',
        enterRecipientPhone: '请输入收件人手机号',
        enterRecipientPhone1: '+86 (中国大陆）',
        recipientAdress: '收件人地址',
        addressProvince: '请选择省',
        addressCity: '请选择市',
        addressCounty: '请选择区',
        addressDetail: '详细地址',
        enteraddressDetail: '请输入详细地址',
        isDefaultInvoice1: '设为默认收件地址',
        sure: '确认',
        cancel:'取消',

        deleteAddressText:'您确定要删除该收货地址吗？',
        deleteOk:'删除',

        invoiceManagement:'发票管理',
        deliveryAddressManagement:'收件地址管理',
        address:'收件地址',
        addAddress:'新增收件地址',
        management_name:'姓名',
        management_mobile:'手机号码',
        management_address:'发票地址',
        management_operation:'操作',

        setToDefault:'设为默认',
        defaultTitle:'默认地址',
        modify:'修改',
        delete:'删除',
        noAddressInfo1:'暂无可用收件地址，请先',
        noAddressInfo2:'新增收件地址',

    },

    myCoupons: {
        loading: '正在加载中',
        close: '关闭',
        coupons: '优惠券',
        couponsRule: '优惠券规则：',
        couponsTip1: '1. 一个产品ID最多限用1张满减券，一张打折券（设置可叠加）／一张满减券或一张打折券（设置不可叠加），按面值金额减免支付，且只有在满足金额要求的情况下才可以打折或满减。默认选择减免金额最多的方式，若打折券减免的多就默认帮用户选择打折券，若满减券减免的多，就默认帮用户选择满减券。同类优惠券有多个的情况只能使用一张该类别券',
        couponsTip2: '2. 优惠券只能抵扣订单金额，优惠金额超出订单金额部分不能再次使用，不能兑换现金',
        couponsTip3: '3. 优惠券等抵扣金额不能开具发票',
        couponsTip4: '4. 优惠券有使用期限限制，过了有效期不能使用',
        learnMore: '了解更多',
        up: '收起',
        count: '张数：',
        id: '代金券/ID',
        type: '类别',
        all: '全部',
        discount: '折扣券',
        markDown: '满减券',
        priceLimit: '金额限制(￥)',
        source: '来源',
        event: '活动领取',
        system: '系统发放',
        code: '激活券码',
        eventRule: '活动规则',
        validUntil: '有效期',
        applicable: '适用产品',
        generalOptics: '普通光学',
        luminous: '夜光',
        video: '视频',
        multispectral: '多光谱',
        operate: '操作',
        useNow: '立即使用',
        delete: '删除',
        nodata: '暂无数据',
        deleteSuccess: '删除成功',
        activate: '激活优惠券',
        useable: '可使用',
        used: '已使用',
        expired: '已过期'
    },

    couponsActivation: {
        loading: '正在加载中',
        close: '关闭',
        coupons: '优惠券',
        activate: '激活优惠券',
        tip1:'1. 优惠券激活码为16位。激活仅针对线下获取的优惠券，系统发放和自主领取的优惠券无需激活',
        tip2:'2. 如您对优惠券有任何疑问，请联系客服电话',
        input: '请输入激活码',
        code: '激活码',
        code12:'请输入12位激活码',
        clear: '清空',
        activate2: '激活',
        back: '返回',
        top12: '激活码位数最多为12位',
        wrong: '请输入正确的激活码',
        success: '激活码兑换成功',
        used: '该激活码已使用',
        expired: '该激活码已过期',
        notExist: '该激活码不存在'
    },
    pricing: {
        dataPrice: '吉林一号数据定价',
        dec: '多种类型卫星数据价格更低、响应更快、服务更优，全方位满足您的需求',
        getMore: '获取更多报价',
        dataType: '数据类型',
        type1: '普通光学',
        type2: '多光谱',
        type3: '夜光',
        type4: '视频',
        resolving: '分辨率',
        resolving1: '优于1m',
        resolving2: '优于5m',
        reTitle: "吉林一号”星座遥感影像库中的数据，可在遥感易购\n查询订购,标准产品在线支付后即时交付，融合镶嵌处\n理为支付后 5个工作日内交付。",
        archivedData: '存档数据',
        archivedData1: '45元/平方公里',
        archivedData2: '5元/平方公里',
        archivedData3: '100元/平方公里',
        archivedData4: '25,000元/段',
        archivedTitle: ' 在参考天气预报和编程冲突情况下，按客户要求，\n' +
            '正常排队处理，安排 7-60 天内拍摄数据，拍摄\n' +
            '后5个工作日内交付的数据，为常规编程服务。',
        generalPro: '常规编程',
        generalPro1: '90元/平方公里',
        generalPro2: '9元/平方公里',
        generalPro3: '180元/平方公里',
        generalPro4: '45,000元/段',
        generalTitle: ' 提交订单后 24 小时至 7 天内拍摄，并于拍摄后 3 \n' +
            '个工作日内交付的数据或指定时间指定区域非轨道\n' +
            '拍摄任务中的数据，为极速编程服务。极速编程服\n' +
            '务无法过滤天气因素的影响。',
        fastProgram: '极速编程',
        fastProgram1: '240元/平方公里',
        fastProgram2: '50,000元/次',
        fastTitle: '提供最快的编程响应时间，用户指定拍摄日期后，\n' +
            '自上注开始到数据交付不多于 24 小时，为应急\n' +
            '编程服务。应急编程服务无法过滤天气因素的影响。',
        emergencyPro: '应急编程',
        emergencyPro1: '100,000元/次以上',
        buyNow: '立即订购',
        title: '常见问题',
        card1Title: '数据产品默认处理方式有哪些',
        card1Content1: '及',
        card1Content2: '产品级别为了完成',
        card1Content3: '辐射校正',
        card1Content4: '经过了传感器及卫星平台引起的',
        card1Content5: '误差校正',
        card1Content6: '并优化后的影像级别',
        card1Content21: '产品为经',
        card1Content22: '辐射校正、传感器、贝尔色彩重建',
        card1Content23: '后的产品，每帧均附带RPC模型参数文件',
        card1Content31: '空间配准及组帧',
        card1Content32: '后建立的视频影像，附带主帧影像及RPC模型参数文件。',
        card1Content33: '点击查看“吉林一号”标准产品说明',
        card2Title: '数据产品可以做融合镶嵌处理吗',
        card2Content11: '所有普通光学、多光谱和夜光影像均',
        card2Content12: '默认未经融合镶嵌处理',
        card2Content21: '需数据',
        card2Content22: '融合处理',
        card2Content23: '的额外增加原始数据总费用的10%价格',
        card2Content31: '镶嵌拼接处理',
        card2Content32: '的额外增加原始数据总费用的20%价格',
        card2Content33: '  组帧后的视频影像（avi）不支持镶嵌',
        card3Title: '各类型数据产品起订规则是什么',
        card3Content11: '存档',
        card3Content12: '数据：遥感易购',
        card3Content13: '在线剪裁购买',
        card3Content14: '查看教程',
        card3Content15: '所支持最小尺寸为准',
        card3Content21: '编程',
        card3Content22: '数据：',
        card3Content23: '最小起订面积为',
        card3Content24: '默认为',
        card3Content25: '时长30s',
        card3Content26: '的指定区域的凝视视频， 区域范围为 ',
        card4Title: '数据交货期为多久',
        card4Content11: '标准产品支付后',
        card4Content12: '即时交付',
        card4Content13: '融合镶嵌处理为支付后',
        card4Content14: '融合镶嵌处理为支付后',
        card4Content15: '内',
        card4Content21: '数据拍摄成功后',
        card4Content22: '5个工作日',
        card4Content23: '交付数据',
        card4Content31: '3个工作日',
        card4Content32: '交付，无法过滤天气因素的影响',
        card4Content41: '自上注开始到数据交付',
        card4Content42: '不多于24小时',
        card4Content43: '，无法过滤天气因素的影响',
        contactUs: '联系我们',
        market: '市场',
        phone: '电话',
        company: '长光卫星技术股份有限公司',
        close: '关闭',
        buzhichi: '您的浏览器不支持视频播放',
    },
    constellation: {
        title1: '吉林一号星座',
        title2: '多种类型卫星数据价格更低、响应更快、服务更优，全方位满足您的需求',
        btn: '订购数据',
        description: 'need to update',
        subTitle1:"详细参数",
        subTitle2:"主要用途",
        subTitle3:"样例数据",
        jilin: '吉林一号',
        param: '参数',
        imageMode: '成像模式',
        resolution: '分辨率',
        bounds: '谱段',
        imageTime: '连续成像时间',
        accuracy: '无控定位精度',
        track: '降焦点地方时',
        range: '幅宽',
        cover: '地面覆盖范围',
        swingAngle: '最大测摆角',
        mass: '卫星总质量',
        life: '设计寿命',
        revisitPeriod: '重访周期',
        rocket: '运载火箭',
        launchSite: '发射地点',
        channel: '数传通道',
        img1: '城市遥感产品',
        img2: '农业遥感产品',
        img3: '林业遥感产品',
        img4: '水利遥感产品',
        img5: '生态环保遥感产品',
        desc: '“吉林一号”卫星遥感影像已广泛应用于国土资源监测、土地测绘、矿产资源开发、智慧城市建设、交通设施监测、农业估产、林业资源普查、生态环境监测、防灾减灾及应急响应等领域。',
        nosupport: '您的浏览器不支持视频播放',
        backTop: '回到顶部',

        satellite1Name: '光学A星',
        satellite1Text: '“光学A星”是长光卫星技术股份有限公司自主研发的第一颗高分辨率商业遥感卫星，作为“一箭四星”的主星，于2015年10月7日在酒泉卫星发射基地成功发射，具有成像谱段多、重访时间短、快速机动能力强等特点。',
        satellite1ImageMode: '常规推扫、大角度侧摆、条带拼接、立体成像',
        satellite1Resolution: '全色：0.72m、多光谱：2.88m',
        satellite1Bounds: '推扫：全色 400-800nm  蓝色 450-520 nm  绿色 520-600 nm  红色 630-690 nm  模拟近红外 690-800 nm ',
        satellite1Accuracy: '200米',
        satellite1track: '10：30am',
        satellite1range: '≥11.6km',
        satellite1cover: '暂无描述',
        satellite1imageTime: '暂无描述',
        satellite1mass: '<420千克',
        satellite1life: '＞3年',
        satellite1revisitPeriod: '3.3天',
        satellite1rocket: '长征二号丁运载火箭',
        satellite1launchSite: '中国酒泉卫星发射中心',

        gaofenSatelliteName:'高分02系列',
        gaofenSatelliteText: '“高分02系列”卫星是长光卫星技术股份有限公司自主研发的第二代高分辨率光学遥感卫星，目前共有4颗在轨运行。该星采用了长焦距光学双相机共基准装调，结合双频GNSS定轨及高精度双星敏定姿技术，具备高分辨、大幅宽、高定位精度、高速数传等特点。',
        gaofenSatelliteImageMode: '常规推扫',
        gaofenSatelliteResolution: '全色：0.75m，多光谱：3m',
        gaofenSatelliteBounds: '全色 450-700nm 蓝色450-510nm 绿色 510-580nm 红色 630-690nm  近红外 770-895nm',
        gaofenSatelliteAccuracy: '优于20米',
        gaofenSatellitetrack: '11：30am',
        gaofenSatelliterange: '≥40km',
        gaofenSatellitecover: '暂无描述',
        gaofenSatelliteimageTime: '暂无描述',
        gaofenSatellitemass: '<230千克',
        gaofenSatellitelife: '＞3年',
        gaofenSatelliterevisitPeriod: '暂无描述',
        gaofenSatelliterocket: '快舟一号甲运载火箭',
        gaofenSatellitelaunchSite: '中国酒泉/太原卫星发射中心',
        gaofenSatellitechannel: '暂无描述',

        gaofen03AName: '高分03A',
        gaofen03AText: '2019年6月5日，“吉林一号”星座“高分03A星”在黄海海域发射升空，“高分03A星”长光卫星技术股份有限公司自主研发的第三代高分辨率光学遥感卫星，该星采用轻量化结构设计、高度集成电子学系统、高分辨率超轻量化低成本相机等创新技术，具有低成本、低功耗、低重量、高分辨的特点。',
        gaofen03AImageMode: '常规推扫、多目标推扫成像、空间目标成像',
        gaofen03AResolution: '全色：优于1m，多光谱：优于4m',
        gaofen03ABounds: '全色 450-700nm 蓝色450-510nm 绿色 510-580nm 红色 630-690nm  近红外 770-895nm',
        gaofen03AAccuracy: '优于100米（CE90，双星敏有效区域）',
        gaofen03Atrack: '11：00am',
        gaofen03Arange: '≥17km',
        gaofen03Acover: '暂无描述',
        gaofen03AimageTime: '暂无描述',
        gaofen03Amass: '<40千克',
        gaofen03Alife: '＞3年',
        gaofen03ArevisitPeriod: '暂无描述',
        gaofen03Arocket: '长征十一号运载火箭',
        gaofen03AlaunchSite: '中国黄海海域',
        gaofen03Achannel: '暂无描述',

        gaofen03BName:'高分03B系列',
        gaofen03BText:'2020年9月15日，6颗“吉林一号”星座“高分030B”系列卫星在黄海海域发射升空。该星充分继承了“吉林一号”星座“高分03A星”成熟单机及技术基础，通过采用轻量化结构设计、高度集成电子学系统、高分辨率超轻量化低成本相机等创新技术，具有低成本、低功耗、低重量、高分辨的特点。',
        gaofen03BImageMode:'高分03B推扫星：常规推扫、多目标推扫成像、空间目标成像；高分03C视频星：常规凝视成像、多目标凝视成像、空间目标成像、夜光成像',
        gaofen03BResolution:'全色：优于1m，多光谱：优于4m',
        gaofen03BBounds:'全色 450-700nm 蓝色450-510nm 绿色 510-580nm 红色 630-690nm 近红外 770-895nm',
        gaofen03BAccuracy:'高分03B推扫星：优于100米（CE90，双星敏有效区域）；高分03C视频星：优于300米（CE90，双星敏有效区域）',
        gaofen03Btrack:'9：20am',
        gaofen03Brange:'≥17km',
        gaofen03Bcover:'12000*5000（高分03C视频星）',
        gaofen03BimageTime:'高分03B推扫星：300s；高分03C视频星：120s',
        gaofen03Bmass:'<42千克',
        gaofen03Blife:'＞3年',
        gaofen03BrevisitPeriod:'单星：12天；组星：4天（星下点）',
        gaofen03Brocket:'长征十一号运载火箭',
        gaofen03BlaunchSite: '中国黄海海域',
        gaofen03Bchannel: '多档可设，最高450Mbps，最低37.5Mbps',

        gaofen03CName:'高分03C系列',
        gaofen03CText:'2020年9月15日，3颗高分03C视频成像卫星搭载长征十一号运载火箭在我国黄海海域成功发射。该星充分继承了“吉林一号”星座“高分03A星”成熟单机及技术基础，通过采用轻量化结构设计、高度集成电子学系统、高分辨率超轻量化低成本相机等创新技术，具有低成本、低功耗、轻重量、高分辨、等特点。',
        gaofen03CImageMode:'高分03C推扫星：常规推扫、多目标推扫成像、空间目标成像；高分03C视频星：常规凝视成像、多目标凝视成像、空间目标成像、夜光成像',
        gaofen03CResolution:'优于1.2m',
        gaofen03CBounds:'RGB（贝尔编码彩色）',
        gaofen03CAccuracy:'高分03C推扫星：优于100米（CE90，双星敏有效区域）；高分03C视频星：优于300米（CE90，双星敏有效区域）',
        gaofen03Ctrack:'9：20am',
        gaofen03Crange:'12000*5000',
        gaofen03Ccover:'12000*5000（高分03C视频星）',
        gaofen03CimageTime:'高分03C推扫星：300s；高分03C视频星：120s',
        gaofen03Cmass:'<42千克',
        gaofen03Clife:'＞3年',
        gaofen03CrevisitPeriod:'单星：12天；组星：4天（星下点）',
        gaofen03Crocket:'长征十一号运载火箭',
        gaofen03ClaunchSite: '中国黄海海域',
        gaofen03Cchannel: '多档可设，最高450Mbps，最低37.5Mbps',

        gaofen03DName:'高分03D系列',
        gaofen03DText:'2021年7月3日，3颗“高分03D”系列卫星在太原卫星发射中心发射升空，该系列卫星是长光卫星技术股份有限公司的卫星批产产品，通过采用轻量化结构设计、高度集成电子学系统、高分辨率超轻量化低成本相机等创新技术，使整星实现分辨率优于0.75m，幅宽大于17km的静态推扫影像情况下，重量控制在40kg量级，具有低成本、低功耗、低重量、高分辨的特点。',
        gaofen03DImageMode:'高分03D推扫星：常规推扫、多目标推扫成像、空间目标成像；高分03C视频星：常规凝视成像、多目标凝视成像、空间目标成像、夜光成像',
        gaofen03DResolution:'全色：优于1m，多光谱：优于4m',
        gaofen03DBounds:'全色 450-700nm 蓝色450-510nm 绿色 510-580nm 红色 630-690nm 近红外 770-895nm；',
        gaofen03DAccuracy:'高分03D推扫星：优于100米（CE90，双星敏有效区域）；高分03C视频星：优于300米（CE90，双星敏有效区域）',
        gaofen03Dtrack:'9：20am',
        gaofen03Drange:'≥17km',
        gaofen03Dcover:'12000*5000（高分03C视频星）',
        gaofen03DimageTime:'高分03D推扫星：300s；高分03C视频星：120s',
        gaofen03Dmass:'<42千克',
        gaofen03Dlife:'＞3年',
        gaofen03DrevisitPeriod:'单星：12天；组星：4天（星下点）',
        gaofen03Drocket:'长征十一号运载火箭',
        gaofen03DlaunchSite: '中国黄海海域',
        gaofen03Dchannel: '多档可设，最高450Mbps，最低37.5Mbps',


        gaofenSatellite3Name:'高分02B',
        gaofenSatellite4Name:'高分02D',
        gaofenSatellite5Name:'高分02F',

        satellite2Name: '视频01/02星',
        satellite2Text: '“视频01/02星”是长光卫星技术股份有限公司研发的第一代彩色视频卫星，也是世界首颗彩色视频组星，于2015年10月在酒泉卫星发射中心发射，运行在656公里的太阳同步轨道上，分辨率1.13m，幅宽超过4.6km，具备视频凝视成像和凝视点波束数传的能力，可以获取4k高清彩色视频影像。',
        satellite2ImageMode: '凝视视频',
        satellite2Resolution: '1.13米',
        satellite2Bounds: 'RGB Bayer 430-720nm',
        satellite2Accuracy: '500米',
        satellite2track: '10：30am',
        satellite2range: '4.6km × 3.4km',
        satellite2cover: '4.6km×3.4km',
        satellite2imageTime: '暂无描述',
        satellite2mass: '<95千克',
        satellite2life: '＞1年',
        satellite2revisitPeriod: '3.3天',
        satellite2rocket: '长征二号丁运载火箭',
        satellite2launchSite: '中国酒泉卫星发射中心',

        satellite3Name: '灵巧验证星',
        satellite3Text: '灵巧验证星是长光卫星技术股份有限公司进行非沿轨成像和国产CMOS传感器的技术验证卫星，采用大量工业级器件，也是世界首颗灵巧成像卫星。于2015年10月搭载长征二号丁运载火箭在酒泉卫星发射中心成功发射，具备多种成像模式。',
        satellite3ImageMode: '常规推扫、凝视视频、灵巧成像、立体成像',
        satellite3Resolution: '4.7米',
        satellite3Bounds: '视频：全色',
        satellite3Accuracy: '500米',
        satellite3track: '10：30am',
        satellite3range: '9.6公里',
        satellite3cover: '暂无描述',
        satellite3imageTime: '暂无描述',
        satellite3mass: '<57千克',
        satellite3life: '＞1年',
        satellite3revisitPeriod: '3.3天',
        satellite3rocket: '长征二号丁运载火箭',
        satellite3launchSite: '中国酒泉卫星发射中心',

        satellite4Name: '视频03星',
        satellite4Text: '2017年1月9日，由长光卫星技术股份有限公司自主研发的视频03星（林业一号），搭载快舟一号甲运载火箭在酒泉卫星发射中心成功发射。',
        satellite4ImageMode: '凝视视频、常规推扫',
        satellite4Resolution: '0.92m',
        satellite4Bounds: 'RGB Bayer 430-720nm',
        satellite4Accuracy: '200米',
        satellite4track: '10：30am',
        satellite4range: '≥11km',
        satellite4cover: '11km×4.5km',
        satellite4imageTime: '120s (一次成像）',
        satellite4mass: '<57千克',
        satellite4life: '1-3年',
        satellite4revisitPeriod: '3.3天',
        satellite4rocket: '快舟一号甲小型运载火箭',
        satellite4launchSite: '中国酒泉卫星发射中心',

        satellite5Name: '视频04-06星',
        satellite5Text: '2017年11月21日，由长光卫星技术股份有限公司自主研发的“吉林一号”星座“视频04-06星”在太原卫星发射中心发射升空。该星基于视频03星基础上进行了部分技术改进与升级。',
        satellite5ImageMode: '凝视视频成像、常规推扫、微光成像、惯性空间成像',
        satellite5Resolution: '0.92m',
        satellite5Bounds: '视频：RGB（贝尔编码彩色） 推扫：全色 450-800nm 蓝色450-510nm 绿色 510-580nm 红色 630-690nm 红边 705-745nm 近红外 770-895nm',
        satellite5Accuracy: '100米（CE90）',
        satellite5track: '12：00am',
        satellite5range: '≥11km',
        satellite5cover: '19km×4.5km',
        satellite5imageTime: '120s (一次成像）',
        satellite5mass: '<208千克',
        satellite5life: '＞3年',
        satellite5revisitPeriod: '暂无描述',
        satellite5rocket: '长征六号运载火箭',
        satellite5launchSite: '中国太原卫星发射中心',

        satellite6Name: '视频07/08星',
        satellite6Text: '2018年1月19日，长光卫星技术股份有限公司自主研发的“吉林一号”星座“视频07-08星”在酒泉卫星发射中心发射升空。该星基于视频03星基础上进行了部分技术改进与升级。',
        satellite6ImageMode: '凝视视频成像、常规推扫、微光成像、惯性空间成像',
        satellite6Resolution: '0.92m',
        satellite6Bounds: '视频：RGB（贝尔编码彩色） 推扫：全色 450-800nm 蓝色450-510nm 绿色 510-580nm 红色 630-690nm 红边 705-745nm 近红外 770-895nm',
        satellite6Accuracy: '100米（CE90）',
        satellite6track: '10：30am',
        satellite6range: '≥11km',
        satellite6cover: '19km×4.5km',
        satellite6imageTime: '120s (一次成像）',
        satellite6mass: '<208千克',
        satellite6life: '＞3年',
        satellite6revisitPeriod: '暂无描述',
        satellite6rocket: '长征十一号运载火箭',
        satellite6launchSite: '中国酒泉卫星发射中心',

        kuanfuSatellite1Name: '“红旗一号-H9”卫星',
        kuanfuSatellite1Text: '2020年1月15日，“红旗一号-H9”卫星在太原卫星发射中心发射升空。“红旗一号-H9”卫星是长光卫星技术股份有限公司自主研发的新型高性能光学遥感卫星。该星充分继承了“吉林一号”星座卫星成熟单机及技术基础，首次采用大口径大视场长焦距离轴三反式光学系统设计，是当时全球幅宽最大的亚米级光学遥感卫星，具备高分辨、超大幅宽、高速存储、高速数传等特点。',
        kuanfuSatellite1Resolution: '全色:优于0.75m，多光谱:优于3m',
        kuanfuSatellite1Bounds: '全色 450-700nm 蓝色450-510nm 绿色 510-580nm 红色 630-690nm  近红外 770-895nm',
        kuanfuSatellite1track: '10：00am',
        kuanfuSatellite1range: '≥136km',

        kuanfuSatellite2Name: '“内蒙古一号”卫星',
        kuanfuSatellite2Text: '2021年7月3日，“内蒙古一号”卫星在太原卫星发射中心发射升空，该星充分继承了“红旗一号-H9”卫星的成熟技术，具备高分辨、超大幅宽、高速存储、高速数传等特点，其幅宽大于150km，每天可获取超过200万km²的高清影像，可为用户提供0.5m全色，2m多光谱分辨率的影像产品。',
        kuanfuSatellite2Resolution: '全色:0.5m，多光谱:优于2m',
        kuanfuSatellite2Bounds: '全色 450-700nm 蓝色450-510nm 绿色 510-580nm 红色 630-690nm  近红外 770-895nm',
        kuanfuSatellite2track: '10：00am',
        kuanfuSatellite2range: '≥150km',

        guangpuName: '光谱01/02星',
        guangpuText: '2019年1月21日，“吉林一号”星座“光谱01-02星”在酒泉卫星发射中心发射升空，该系列卫星搭载了多光谱成像仪，短波、中波、长波红外相机、“水运一号”系统等载荷，具有星上智能处理系统，可获取5m分辨率、110km幅宽、26谱段的遥感数据。',
        guangpuResolution: '可见光近红外：5m；短波、中波红外：100m；长波红外：150m',
        // guangpuBounds: 'B0:450nm-800nm <br/> B1:403nm-423nmB2:433nm-453nm B3:450nm-515nm B4:525nm-600nm B5:630nm-680nm B6:784.5nm-899.5nm  B7:485nm-495nm B8:615nm-625nm  B9:650nm-680nm B10:698.75nm-718.75nm B11:732.5nm-747.5nm   B12:773nm-793nm  B13:855nm-875nm  B14:660nm-670nm B15:677.5nm-685nm  B16:750nm-757.5nm  B17:758.75nm-762.75nm  B18:935nm-955nm B19:1000nm-1040nm  SW1:1195nm-1225nm SW2:1360nm-1390nm      SW3:1550nm-1590nm SW4:1610nm-1690nm   MW:3700nm-4950nm LW:7500nm~13500nm',
        guangputrack: '12：00am',
        guangpurange: '≥110km',



    },


    //access
    badge: '徽章',
    dataIterator: {
        rowsPerPageText: '每页记录数：',
        rowsPerPageAll: '全部',
        pageText: '{0}-{1} 共 {2} 条',
        noResultsText: '没有找到匹配记录',
        nextPage: '下一页',
        prevPage: '上一页'
    },
    dataTable: {
        rowsPerPageText: '每页行数：'
    },
    noDataText: '无可用数据',
    app:{
        title: '长光卫星 生态开放商城',
        savedProduct: '存档数据',
        demand: '编程摄影',
        loginRemind: '请登录后进行操作',
        targetLibrary: '目标库',
        customizeTargetLibrary: '我的位置点',
        aisTargetLibrary: 'AIS目标库',
        comingSoon: '敬请期待',
        dataManagement: '数据管理',
        myOrder: '我的订单',
        orbitalSimulation: '轨道模拟',
        allSatellites: '全部卫星',
        visibilityAnalysis: '可见性分析',
        feedback: '意见反馈',
        clickToLogin: '登录/注册',
        submittedSuccessfully: '提交成功',
        close: '关闭',
        warning1: '请输入标题！',
        warning2: '请输入内容！',
        invalid: '登录状态失效，请重新登录'
    },
    search: {
        main: {
        favorite: '收藏',
        measure: '测量',
        exit: '退出',
        cancel: '取消',
        chromeTip: '为了您更好的使用体验，推荐使用Chrome浏览器访问本站点',
        clickToDownload: '点击下载',
        favoriteName: '收藏名称',
        add: '添加',

        selectedArea: '所选面积为',
        selectedPoint: '所选点坐标',
        selectedLine: '所选线长度',
        selectedFile: '选择文件范围',
        selectedPoiCollection: '选择POI集合',


        disabledInTargetMode: '目标点模式下无法使用此功能',
        geographicalRange: '地理范围',
        advancedCondition: '高级条件',
        search: '查询',
        collapseResults: '收起查询结果',
        expandResults: '展开查询结果',
        searching: '正在查询...',
        close: '关闭',
        sum1: '“吉林一号”星座目前共',
        sum2: '颗卫星。标准影像产品共计',
        sum3: '景。影像总面积',
        sum4: '平方公里',
        sum5: '搜索结果：存档数据共计',
        sum6: '景。拍摄面积共计',
        sum7: '平方公里。',
        sum9: '存档数据共计',
        sum10: '平方公里。',
        viewDataCoverage: '查看数据覆盖',
        targetMode: '目标点模式',
        targetModeOn: '点目标检索模式已开启',
        targetModeInfo: '点击检索范围内任意位置，实现该点历史影像快速检索，并通过时间轴与列表展示。',
        reselect: '重新选取',
        generalOptics: '光学',
        luminous: '夜光',
        video: '视频',
        multispectral: '多光谱',
        squareKilometer: '平方公里',
        noResults: '无相关结果',
        errorText1: '请选择范围内的点',
        research: '重新选择搜索条件',
        gotoPrograming: '新建编程摄影'
        },
        measure: {
        distance: '测距离',
        area: '测面积',
        distance2: '距离:',
        area2: '面积:',
        delete: '删除',
        start: '起点',
        },
        favorite: {
        selected: '已选：',
        favorites: ' 个收藏',
        delete: '删除',
        point: '收藏点',
        linestring: '收藏线',
        polygon: '收藏区域',
        file: '收藏上传文件',
        search: '查询',
        keyword: '请输入关键字'
        },
        cropBuy:{
        selectTip:'请选择需要剪裁的区域',
        cropBuy: '剪裁购买',
        selected: '已选择 ',
        areas: ' 个区块，面积 ',
        buyNow: '立即购买'
        },
        rangeSelector: {
        confirm: '确定',
        point: '绘制点',
        rectangle: '绘制矩形',
        polygon: '绘制多边形',
        linestring: '绘制线',
        pointTarget: '点坐标',
        drawingArea: '绘制',
        regionalCoordinates: '区域坐标',
        administrativeRegions: '行政区域',
        uploadFiles: '上传文件',
        startDrawing: '点击开始绘制',
        centerPoint: '中心点',
        leftUpLongitude: '左上经度',
        leftUpLatitude: '左上纬度',
        rightDownLongitude: '右下经度',
        rightDownLatitude: '右下纬度',
        centerLongitude: '中心点经度',
        centerLatitude: '中心点纬度',
        centerLength: '距中心点长度(公里)',
        centerWidth: '距中心点宽度(公里)',
        centerRadius: '半径(公里)',
        china: '国内',
        world: '国外',
        province: '省份',
        city: '城市',
        county: '区县',
        country: '国家',
        reset: '重置',
        required: '必填项',
        illegal: '不合法',
        gt0: '需大于0',
        degree: '十进制度',
        dms: '度分秒',
        longitude: '经度',
        latitude: '纬度',
        d: '度',
        m: '分',
        s: '秒',
        upload1: '点击或将文件拖拽到这里上传',
        upload2: '支持扩展名.kml .kmz',
        upload3: '.zip(需包含.shp和.prj)',
        selected: '已选择:'
        },
        standardProduct: {
        JL101A: '光学A星(0.72m)',
        JL1GF02AB: '高分02A/02B星(0.75m)',
        JL1KF01A: '宽幅01A星(0.75m)',
        JL103B: '视频03星(0.92m)',
        JL10XB: '视频04/05/06/07/08星(0.92m)',
        JL1GF03A: '高分03星(1m)',
        JL1GF03B: '高分03B系列(1m)',
        JL1GF03C: '高分03C系列(1m)',
        JL1GP0102: '光谱01/02星(5m)',
        confirm: '确定',
        reset: '重置',
        type: '类型',
        gsd: '星下点分辨率',
        productId: '产品ID',
        productType: '选择产品类型',
        productBand: '选择数据谱段',
        satellite1: '选择卫星',
        satellite2: '选择卫星，可切换选择分辨率区间',
        imageGsd1: '选择分辨率区间',
        imageGsd2: '选择分辨率区间，可切换选择卫星',
        cloudPercent: '云量要求',
        rollSatelliteAngle: '侧摆要求',
        startTime: '起始日期',
        endTime: '终止日期'
        },
        standardResult: {
        generalOptics: '光学',
        luminous: '夜光',
        video: '视频',
        multispectral: '多光谱',

        buyNow: '立即购买',
        addToCart: '加入购物车',
        cropBuy: '裁剪购买',
        cropBuyTip: '该类型产品不支持剪裁购买',

        targetMode: '筛选点',
        bands: '谱段',
        perpage: '每页',
        years: '年份',
        purchase: '购买所选项',
        targetModeTip: '点击检索范围内任意位置',
        searching: '正在查询，请稍后...',
        noResults: '很抱歉 该分类下没有相关搜索结果',
        hideThumbnail: '隐藏缩略图',
        showThumbnail: '显示缩略图',
        detail: '查看详情',
        confirmLevel: '请确认您选择的产品处理级别',
        standardProduct: '标准产品',
        orthogonalFusionProduct: '正射融合产品',
        mosaicProduct: '镶嵌产品',
        cancel:'取消',
        submit: '提交',
        jumpTip: '请切换至新页面确认订单',
        close: '关闭',
        band: '谱',
        all: '全部',
        allyears: '年份: 全部',
        allbands: '谱段: 全部',
        satellite: '卫星',
        gsd: '分辨率',
        imagingTime: '拍摄时间',
        cloudPercent: '云量',
        rollSatelliteAngle: '侧摆',
        noMoreResults: '没有更多结果了',
        scrollOrClick: '点击或滚动到底部加载更多'
        },
        cart: {
        cart: '购物车',
        total:'共计',
        scenes:'景数据',
        selected:'已选: ',
        delete:'删除所选项',
        purchase: '购买所选项',
        shp:'导出Shp',
        deleteConfirm: '是否删除所选项',
        confirm: '删除',
        cancel: '取消',
        price: '价格',
        totalPrice: '总额: ',
        tip: '卫星基础数据根据实际产品面积进行计费，本页金额为标准产品指导价格，实际售价以结算页最终价格为准。',
        }
    },
    satelliteId:{
        'JL101A': '光学A星',
        'JL103B': '视频03星',
        'JL104B': '视频04星',
        'JL105B': '视频05星',
        'JL106B': '视频06星',
        'JL107B': '视频07星',
        'JL108B': '视频08星',
        'JL101C': '光谱01星',
        'JL102C': '光谱02星',
        'JL101D': '高分03星',
        'JL101E': '高分02A星',
        'JL102E': '高分02B星',
        'JL101K': '宽幅01A星',
        'JL1GP01': '光谱01星',
        'JL1GP02': '光谱02星',
        'JL1GF03A': '高分03星',
        'JL1GF02A': '高分02A星',
        'JL1GF02B': '高分02B星',
        'JL1KF01A': '宽幅01A星',
        'JL1KF01B': '宽幅01B星',
        'JL1GF03B01': '高分03B01星',
        'JL1GF03B02': '高分03B02星',
        'JL1GF03B03': '高分03B03星',
        'JL1GF03B04': '高分03B04星',
        'JL1GF03B05': '高分03B05星',
        'JL1GF03B06': '高分03B06星',
        'JL1GF03C01': '高分03C01星',
        'JL1GF03C02': '高分03C02星',
        'JL1GF03C03': '高分03C03星',
        'JL1GF03D01': '高分03D01星',
        'JL1GF03D02': '高分03D02星',
        'JL1GF03D03': '高分03D03星',
        
        //新增的
        'JL1KF01C': '宽幅01C星',
        'JL1GF04A': '高分04A星',
        'JL1GF02D': '高分02D星',
        'JL1GF02F': '高分02F星',
        'JL1GF03D04': '高分03D04星',
        'JL1GF03D05': '高分03D05星',
        'JL1GF03D06': '高分03D06星',
        'JL1GF03D07': '高分03D07星',
        'JL1GF03D08': '高分03D08星',
        'JL1GF03D10': '高分03D10星',
        'JL1GF03D11': '高分03D11星',
        'JL1GF03D12': '高分03D12星',
        'JL1GF03D13': '高分03D13星',
        'JL1GF03D14': '高分03D14星',
        'JL1GF03D15': '高分03D15星',
        'JL1GF03D16': '高分03D16星',
        'JL1GF03D17': '高分03D17星',
        'JL1GF03D18': '高分03D18星',
        'JL1GF03D27': '高分03D27星',
        'JL1GF03D28': '高分03D28星',
        'JL1GF03D29': '高分03D29星',
        'JL1GF03D30': '高分03D30星',
        'JL1GF03D31': '高分03D31星',
        'JL1GF03D32': '高分03D32星',
        'JL1GF03D33': '高分03D33星',
    },
    searchBar: {
        tip:'查地点、经纬度、目标库、产品ID',
        snackbar:'例：22.9621,113.9826，逗号分隔',
        targetLibrary: '目标库',
        noResults: '暂无相关结果',
        poiCollections:'POI集合',
        all: '全部:',
        coordinate: '经纬度',
        productId: '产品ID',
        lat: '纬度:',
        lng: '经度:',
    },
    standardProductDetail: {
        select: '选择本产品',
        zoomIn: '点击放大',
        bands: '谱段数:',
        detail: '详情',
        generalOptics: '普通光学',
        luminous: '夜光',
        video: '视频',
        multispectral: '多光谱',
        productType: '类型:',
        imagingDate: '日期:',
        imagingTime: '时间:',
        productArea: '面积:',
        imageGsd: '分辨率:',
        cloudPercent:'云量:',
        solarElevation: '太阳高度角:',
        sensor: '传感器:',
        satelliteId: '拍摄卫星:',
        bandCount: '谱段数:',
        rollSatelliteAngle: '侧摆:',
        centerCoordinate: '景中心经纬度:',
        thumbnail: '缩略图:',
        show: '查看',

    },
    layerChanger: {
        layerChange:'底图切换',
        title1: '蓝黑',
        title2: '天地图(默认)',
        title3: '谷歌地图',
        title4: '谷歌影像',
        title5: '天地图影像'
    },
    demandConfirmation: {//NOTE 需求确认页面
        jl1store: '吉林一号生态开放商城',
        requirementName: '输入需求名称',
        requirementNamePlaceholder: '请输入需求名称',
        requirementNameInfo: '需求名称可便于您查找已创建订单',
        requirementNameTip:'不超过20个字符',
        confirmImageInformation:'确认影像信息',
        demandConfirmation: '需求确认',
        // paymentReview: '支付审核',
        paymentReview: '等待审核',
        deliver:'交付',
        appraise:'评价',
        submitOrder: '订单提交',
        requirementNameVerify: ['需求名称不能为空！','需求名称不能超过20个字符！'],
        cutting: '裁剪',
        optional: '非必选项',
        uploadShpFile: '上传矢量文件',
        clickAndUpload: '点击上传',
        reUpload: '重新上传',
        treatmentGrade: '处理等级',
        treatmentGradeExplain: '查看适用说明',
        treatmentGradeExplainTitle: '处理等级适用情形参考',
        treatmentGradeTip: '最多可选2种',
        treatmentGradeItemsOpenTip:['更多','收起'],
        treatmentGradeItems:['L1级传感器校正产品','L3C级系统几何校正融合产品','L3D级系统几何校正可视化产品','L1B级传感器校正反射率产品','L1B_PSH级传感器校正反射率融合产品','L1C级像素级融合产品','L2A级预正射产品','L2B级预正射反射率产品','L2B_PSH级预正射反射率产品融合产品','L2C级预正射融合产品','L2D级预正射可视化产品','L3A级系统几何校正产品','L3B级系统几何校正反射率产品','L3B_PSH级系统几何校正反射率融合产品',/* 'L5级镶嵌产品' */],
        treatmentGradeItemsExplain:['用于专业摄影测量及制图，方便用户可利用自己的处理算法进行后续处理；','用于用户进行专业的地物反演应用；','L1B级别产品的融合后产品，融合后影像实体为单个TIF；','适用于对空间分辨率及光谱分辨率同时具有较高需求的用户，方便用户进行后续处理；','方便用户快速将产品用于特征提取、分类、制图等实际应用中；','用于用户进行专业的地物反演应用；','L2B级别产品的融合后产品，融合后影像实体为单个TIF；','适用于对空间分辨率及光谱分辨率同时具有较高需求的用户；','可视化产品，适用于一般用户的快速查看及制图应用；','适用于对精度有更高需求的用户，方便用户快速将产品用于实际应用中；','适合于对精度有更高需求的用户，用户可将产品用于专业反演应用；','L3B级别产品的融合后产品，融合后影像实体为单个TIF；','适用于对空间分辨率及光谱分辨率同时具有较高需求的用户；','可视化产品，适用于一般用户的快速查看及制图应用；','适用于有大面积数据需求的用户，方便用户快速将产品用于特征提取、分类、制图等实际应用中。'],
        treatmentGradeRedTipShow:'提示：L1B、L1B_PSH、L2B、L2B_PSH、L3B、L3B_PSH级别数据拍摄完成5天后才能进行生产，如遇生产失败，请于拍摄5日后联系我们重新下生产单',
        treatmentGradeRedTipShow1:'提示：光学A星、视频04、05、06、07、08星不支持L1B、L1B_PSH、L2B、L2B_PSH、L3B、L3B_PSH级别生产',
        treatmentGradeRedTipShow2:'提示：光谱01、02星不支持L1B_PSH、L1C、L2B_PSH、L2C、L3B_PSH、L3C级别生产',
        mosaic:'镶嵌',
        mosaicItem:['不镶嵌','镶嵌(3谱8位)','镶嵌(4谱8位)','镶嵌(4谱16位)'],
        projectionMode:['投影方式','WGS84+UTM投影6°带','WGS84+经纬投影','CGCS2000+高斯克吕格6°带','CGCS2000+高斯克吕格3°带'],
        projectionModeTip: ['投影方式', '（默认）', '', '1:25000-1:500000, 仅限光谱卫星', '1:500-1:10000, 仅限亚米级卫星'],
        remark:'备注（选填）',
        remarkVerify:'备注不能超过100个字符！',
    },
    waitForReview: {
        businessManager:'专属商务经理',
        successTip:'订单提交成功，请等待审核~',
        successSubTip:'您的专属商务经理默认将在工作日4小时内、非工作日48小时内联系您并协助您完成订单，请确认您预留的联系方式正确并保持手机畅通。',
        jl1Manager:'吉林一号大区经理',
        contactInformation: '查看商务经理联系方式',
        yourManager:'您的专属商务经理',
        phoneTip1:'请核对您的联系电话',
        phoneTip2:'默认为您的注册手机号',
        contactTime: '请输入您期望的联系时间',
        contactNow:'立即联系',
        contactIn24Hours:'24小时内',
        contactInWorkTime: '工作日工作时间(8:30~17:30)',
        continuePurchase: '继续选购数据',
        viewOrder: '查看订单',
        confirmed: '已确认',
    },
    Archive: {
      sameProductType:'仅支持同类型产品统一购买！',
    },
    orderConfirm: {
        rangeBrowsing: '范围浏览',
        cropBuy: '裁剪购买',
        invoice: '发票信息',
        invoiceTip: '开企业抬头发票须填写纳税人识别号，以免影响报销',
        invoiceEnable: '开具发票',
        coupon: '优惠券',
        couponEnable: '使用优惠券',
        totalCredit: '共抵用',
        zhang: '张',
        noCoupons: '暂无优惠券',
        off: '折',
        over: '满',
        validUntil: '有效期至',
        total: '应付总额：',
        cropping: '裁剪处理',
        range: '区域范围：',
        selectedCrop:'当前选中裁剪面积',
        orderMethod: '订购方式:',
        only: '仅订购裁剪区域',
        onlyTip: '*仅交付tif格式的裁剪区域成果',
        all: '订购全部数据及裁剪区域',
        allTip1: '*交付全部标准产品文件以及',
        allTip2: 'tif格式的裁剪区域成果',
        price: '价格：',
        confirm: '确认',
        cropError: '文件格式错误或与产品无交集，请检查后重新上传',
        totalPrice: '参考价格：',
        discount: '优惠：',
        commodity: '商品券',
        order: '订单券',
        markdownCoupon: '满减券',
        discountCoupon: '满折券',
        uploadedFile: '已上传文件',
        fullDelivery: '全部交付',
        cropDelivery: '剪裁后交付，面积',
        orderDetail: '订单详情',
        noInvoice: '未申请发票',
        makeUp: '补开发票',
        show: '查看',
        realPrice: '应付总额：',
        none: '无',
        orthorectification: '正射校正',
        downgrade: '降位（16位降至8位）',
        enhance: '增强',
        mosaic: '镶嵌',
        allResolution: '全部分辨率组合',
        sameResolution: '相同分辨率组合',

        confirmOrder: '确认订单信息',
        purchaseData: '选购数据',

        submitOrder: '订单提交',
        contectReview: '支付',
        download: '立即下载',
        productId: '产品名称',
        productProperties: '产品属性',
        productType: '类型: ',
        requestName:'需求名称:',
        status:'状态:',
        orderId:'订单号:',
        productLevel: '级别: 标准产品',
        sensor: '传感器: ',
        satelliteId: '拍摄卫星: ',
        cloudPercent:'云量: ',
        rollSatelliteAngle: '侧摆: ',
        imageGsd: '分辨率: ',
        imagingTime: '采集时间: ',
        tip1: '请扫描左侧二维码/电话/邮件联系商务经理分配次数后，即可提交需求',
        tip2: '邮箱: ',
        tip3: '电话:',
        tip4: '当前账户中共计 ',
        tip5: ' 次试用数据服务次数，',
        tip6: ' 次存档数据服务次数',
        total1: '共计选购 ',
        total2: ' 景数据',
        submit: '提交订单',
        myOrder: '查看我的订单',
        continue: '继续检索数据',
        success: '您的订单已提交成功',
        level: '级别',
        standard: '标准产品',
        advanced: '高级处理产品',
        handles: '处理',
        crop: '裁剪',
        cropTip:'如需裁剪请上传 .kml  .kmz 或 包含.shp和.prj的zip文件',
        remark: '备注',
        remarkTip: '请输入备注',
        projection: '投影',
        pattern: '格式',
        longitude: '中心点经度',
        latitude: '中心点纬度',
        size: '尺寸'
    },
    //新增
    demandConfirm: {
        /*pended: '已受理',
        producting: '数据生产中',
        preparing: '数据准备中',
        ready: '数据准备完成',
        canceled: '已取消',
        orderInformation: '订单信息',
        requirment: '拍摄要求',
        deliveryRequirment: '交付要求',
        a1:"需求订单编号：",
        a2:"订单创建时间：",
        a3:"需求名称：",
        a4:"需求类型：",
        a5:"目标类型：",
        a6:"分辨率要求：",
        a7:"云量要求：",
        a8:"侧摆要求：",
        a9:"经度：",
        a10:"纬度：",
        a11:"成像模式：",
        a12:"成像时长：",
        a13:"拍摄时间范围：",
        a14:"备注：",
        a15:"产品级别：",
        a16:"产品交付时间：",
        standardProduct: '标准产品',
        programmingPhotography: '编程摄影',
        startTime: '开始拍摄时间',
        endTime: '结束拍摄时间',
        status: '拍摄状态',
        loading: '载入中，请稍后',
        none: '无',
        pointTarget: '点目标'*/
        title: '确认订单信息',
        name: '需求名称',
        // priorityType: '服务类型',
        priorityType: '优先级',
        time: '拍摄时间',
        imageMode: '成像类型',
        imageGeometry: '成像位置',
        resolution: '分辨率要求',
        cloud: '云量要求',
        rollSatelliteAngle: '侧摆要求',
        processType: '处理级别',
        area: '拍摄面积',
        videoLength: '拍摄时长',
        ProcessingDetail: '处理详情',
        shadow: '投影方式',
        handles: '处理等级',
        pattern: '格式',
        tailor: '是否裁剪',
        remark: '备注',
        transitInquiry: '过境查询',
        invoiceInfo: '发票信息',
        invoiceTitle: '开企业抬头发票须填写纳税人识别号，以免影响报销',
        invoice: '开具发票',
        change: '修改',
        coupon: '优惠券',
        useCoupon: '使用优惠券',
        useCoupon1: '使用优惠券，共抵用',
        useCoupon2: '元：使用优惠券',
        useCoupon3: '张',
        useCoupon4: '满',
        useCoupon5: '有效期至',
        noCoupon: '暂无优惠券',
        totalMoney: '总金额',
        discount: '优惠',
        totalAmount: '应付总额',
        submit: '提交订单',
    },
    //新增
    demand: {
        title1:'快速编程服务',
        title2:'目前“吉林一号”星座已有31颗卫星在轨运行，具备全球任意地点每天9-11次的重访能力。',
        title3:'可获取数据类型包括亚米级普通光学影像、亚米级夜光影像、亚米级视频影像以及大幅宽多谱段的多光谱影像。',
        title4:'根据您的需求提供定制化的拍摄模式。',
        title: '编程摄影信息录入',
        searchPoiName:'查地点、经纬度、目标库',
        minArea: '最小起订面积',
        selectArea: '所选择区域面积',
        selectPoint:'选择此点',
        closeMap:'关闭地图选点',
        areaTargetDialog:'区域目标暂不支持在线提交需求',
        areaTargetDialog1:'请扫描左侧二维码联系在线客服处理或联系长光卫星市场部',
        areaTargetDialog2:'邮箱：market@charmingglobe.com',
        areaTargetDialog3:'电话：0431-86008580',
        requireName: '任务名称',
        requireName1:'输入拍摄任务名称',
        serviceType: '服务类型',
        generalProgrammingServices:"常规编程服务",
        speedProgrammingServices:"极速编程服务",
        emergencyProgrammingServices:"应急编程服务",
        imagingTime: '拍摄时间',
        imagingPosition:"成像位置",
        imagingPosition1:'请输入坐标点纬度经度，示例如11.135，12.356',
        mapSelectPoint:'地图选点',
        transitInquiry:'过境查询',
        timeTitle:'常规编程模式下，提交需求后安排 7-60 天内拍摄数据，拍摄后5个工作日内交付的数据，选择起始时间后系统自动选择结束时间',
        timeTitle1:'极速编程模式下，提交需求后 24 小时至 7 天内拍摄，拍摄后 3 个工作日内交付的数据，选择起始时间后系统自动选择结束时间',
        timeTitle2:'应急编程模式下，选择指定拍摄时间，自上注开始到数据交付不多于 24 小时',
        drawnArea:'已绘制区域',
        coordinateAreaSet:'已设置坐标区域',
        AreaSelect:'已选择行政区域',
        FileUpload:'已上传文件',
        noFileUploda:'无可用文件，无区域范围',
        PositionSee:'位置预览',
        Reselect:'重新选择',
        productLevel: '产品级别',
        deliveryTime: '交付时间',
        resolutionRequirement: '分辨率要求',
        imagingMode: '成像模式',
        imagingDuration: '成像时长',
        rollAngle: '侧摆要求',
        cloudPercent: '云量要求',
        processingLevel: '处理级别',
        projection:'投影',
        process:'处理',
        format:'格式',
        tailor:'裁剪',
        tailor1:'如需裁剪请上传 .kml  .kmz 或 包含.shp和.prj的zip文件',
        CenterLongitude:'中心点经度',
        CenterLatitude:'中心点纬度',
        selectSize:'请选择尺寸',
        orthographic:'正射',
        drop:'降位（16位降至8位）',
        mosaic:'镶嵌',
        enhance:'增强',
        fullResolution:'全部分辨率组合',
        sameResolution:'相同分辨率组合',
        remarks: '备注信息',
        remarks1:'请输入备注信息',
        targetType: '目标类型',
        pointTarget: '坐标点',
        areaTarget: '区域范围',
        longtitude: '经度 ',
        latitude:  '纬度 ',
        switch: '转换',
        reset: '重置',
        transit: '过境查询',
        targetLibrary: '将本次需求加入到目标库',
        targetName: '目标点名称',
        submit: '提交需求',
        tip:'请输入地点或目标库中目标名称',
        operationPrompt: '操作提示',
        confirm: '确认',
        return: '返回',
        queryTime: '查询时间',
        satellite: '选择卫星',
        search: '查询',
        noResults: '对不起，没有符合条件的查询结果。',
        searching: '正在查询...',
        close: '关闭',
        standardProduct: '标准产品',
        orthogonalFusionProduct: '高级处理产品',
        after24: '成像后24小时',
        after48: '成像后48小时',
        after72: '成像后72小时',
        push: '普通光学',
        gaze: '视频',
        luminous: '夜光',
        stereoscopic: '多光谱',
        transitSatellite: '查询卫星',
        transitTableStartTime: '过境开始时间',
        transitTableEndTime: '过境结束时间',
        transitTableSideAngle: '侧摆角',
        transitTableSunAngle: '太阳高度角',
        alert1: '目标点经纬度未输入完整，请重新输入',
        alert2: '目标点的经纬度输入范围不符合规范，请重新输入值(经度范围-180°~180°；纬度范围-90°~90°)',
        alert3: '需求名称未填写，请填写完整',
        alert4: '拍摄结束时间要在开始时间之后，请重新选择时间范围',
        alert5: '目标点名称未填写，请填写完整',
        alert6: '已有该目标点名称，请修改后提交！',
        submiting: '提交中，请稍后',
        success: '需求提交成功！',
        alert7: '请至少选择一个卫星进行过境查询',
        alert8: '过境查询结束时间要在开始时间之后，请重新选择时间范围',
        alert9: '过境查询的时间跨度最大为三天，请重新选择时间范围',
        requestList:'当前需求清单',
        requType:'服务类型',
        imageTime:'拍摄时间',
        imageMode:'成像模式',
        imgagePosition:'成像位置',
        cloud:'云量要求',
        rog:'侧摆要求',
        proLevel:'处理级别',
        imagePrice:'拍摄价格',
        imagePrice1:'处理费用',
        productArea:'产品面积',
        videoLong:'视频时长',
        TotalAmountPay:'应付总额',
        BuyNow:'立即购买',
        CustomerService:'客服',
        BusinessAffairs:'商务',
        email:'邮箱',
        snackbarInfo:'坐标点经纬度输入不合法!',
        snackbarInfo1:'最小起订面积为100km²',
        snackbarInfo2:'请输入需求名称！',
        snackbarInfo3:'纬度输入不合法,请输入-90至90间数字',
        snackbarInfo4:'经度输入不合法,请输入-180至180间数字',
        snackbarInfo5:'请输入中心点纬度',
        snackbarInfo6:'请输入中心点经度',
        title11:"在参考天气预报和编程冲突情况\n下，按客户要求，正常排队处理，\n安排7-60天内拍摄数据，拍摄后\n5个工作日内交付的数据，为常规\n编程服务。",
        title21:"提交订单后24小时至7天内拍摄，\n 并于拍摄后3个工作日内交付的\n数据或指定时间指定区域非轨道\n拍摄任务中的数据，为极速编程\n服务。极速编程服务无法过滤天\n气因素的影响。",
        title31:"提供最快的编程响应时间，在提\n交订单当日 15:00 前提出需求，\n自上注开始到数据交付不多于24\n小时，为应急编程服务。应急编\n程服务无法过滤天气因素的影响。",
        title41:"普通光学影像为分辨率优于 1m的\nL1级全色+多光谱推扫数据，最小\n起订面积为10公里×10公里",
        title5:"视频影像为分辨率优于1m的L1B级\n卫星视频，每段卫星视频默认为时\n长 30s 的指定区域的凝视视频，区\n域的范围为 11 公里×4.5 公里",
        title6:"夜光影像分辨率优于1m，最小\n起订面积为11 公里×4.5 公里",
        title7:"多光谱影像为5m分辨率、20 谱段\n的可见光近红外数据，最小起订面\n积为50公里×50公里",
        title8:"标准产品为默认数据产品级别:\n完成了辐射校正、经过了传感器及\n卫星平台引起的误差校正并优化后\n的影像级别。",
        title9:"高级处理产品为经过正射融合及\n镶嵌处理的高级产品，您可直接\n采用高级处理默认流程。如有特\n殊需求可在以下选项中选择。",
        lat:'目标经度',
        lng: '目标纬度',
        startTime:'起始时间',
        endTime: '结束时间',
        sateResource: '卫星资源',
        SideswayAngle: '侧摆角',
        sunEa: '太阳高度角',
        cloud1:'云量',
        JL101A: '吉林一号光学A星',
        JL103B: '吉林一号视频03星',
        JL104B: '吉林一号视频04星',
        JL105B: '吉林一号视频05星',
        JL106B: '吉林一号视频06星',
        JL107B: '吉林一号视频07星',
        JL108B: '吉林一号视频08星',
        JL101C: '吉林一号光谱01星',
        JL102C: '吉林一号光谱02星',
        JL101E: '吉林一号高分02A星',
        JL102E: '吉林一号高分02B星',
        JL101K: '吉林一号宽幅01星',
        JL101D: '吉林一号高分03A星',
        error1: '经度或纬度未填写完整，请填写完整后查询',
        error2: '经纬度输入范围不符合规范',
        error3: '卫星资源不能为空',
        error4: '时间范围不能为空',
        loading1:'正在查询，请稍后...',
        noData: '暂无相关数据',
    },
    orders:{
        generalProgrammingServices:"常规编程服务",
        speedProgrammingServices:"极速编程服务",
        emergencyProgrammingServices:"应急编程服务",
        close: '关闭',
        productDetail: '产品详情',
        detail: '订单详情',
        loading: '正在加载中',
        cancelOrder: '取消订单',
        cancelOrderConfirm: '确认取消订单',
        confirm: '确认',
        cancel: '取消',
        savedProductOrder: '存档数据订单',
        programmingPhotographyOrder: '编程摄影订单',
        allOrders: '全部订单',
        pending: '待支付',
        pended: '已受理',
        preparing: '进行中',
        paid: '已完成',
        canceled: '已取消',
        pointTargetOrders: '点目标订单',
        areaTargetOrders: '区域目标订单',
        requireName: '需求名称：',
        dataReady: '下载数据',
        view: '查看数据',
        player: '播放器',
        searchTip1: '请输入产品ID或订单号进行搜索',
        searchTip2: '请输入需求名称或订单号进行搜索',
        search: '搜索',
        generalOptics: '普通光学',
        luminous: '夜光',
        video: '视频',
        multispectral: '多光谱',
        all: '全部',
        standardProduct: '标准产品',
        orthogonalFusionProduct: '高级处理产品',
        mosaicProduct: '镶嵌产品',
        a1: '订单号：',
        a2:"提交需求时间：",
        a3:"需求名称：",
        a4:"成像模式：",
        a5:"分辨率：",
        a6:"经纬度：",
        a7:"时间：",
        a8:"传感器：",
        a9:"卫星：",
        a10:"云量：",
        a11:"侧摆：",
        a12:"类型：",
        a13:"级别：",
        a14:"试用数据",
        a15:"存档数据",
        a16:"编程数据",
        a17:"来源：",
        a18:"投影：",
        a19:"格式：",
        a20:"处理：",
        a21:"裁剪：",
        a22:"备注：",
        a23:"经度：",
        a24:"纬度：",
        a25:"尺寸：",
        a26:"服务类型：",
        a27:"总金额： ",
        scene: '景',
        total: '您的账号共计',
        trialPermission: '试用权限，已试用',
        savedProductPermission: '存档权限，已试用',
        programmingPhotographyPermission: '编程权限，已试用',
        success: '订单取消成功',
        failed: '订单取消失败',
        push: '普通光学',
        gaze: '视频',
        stereoscopic: '立体',
    },
    //新增
    invoiceDialog:{
        title: '请您与贵企业财务人员核实，确保提供的发票信息与在税务机关预留的登记信息保持一致，以免影响发票的后续使用。',
        type: '发票类型',
        comInvoice: '增值税普通发票',
        specialInvoice: '增值税专用发票',
        companyName: '单位名称',
        enterCompany: '请输入单位名称',
        code: '纳税人识别号',
        code1: '纳税人识别号',
        enterCode: '请输入纳税人识别号',
        companyAdress: '单位地址',
        companyAdress1: '单位地址',
        enterAdress: '请输入单位地址',
        phone: '单位电话',
        enterPhone: '请输入单位电话',
        bank: '开户银行',
        enterBank: '请输入开户银行',
        bankAccount: '银行账号',
        enterBankAccount: '请输入银行账号',
        isDefaultInvoice: '设为默认抬头',
        nextStep: '下一步',
        cancel: '取消',
        recipientName: '收件人姓名',
        enterName: '请输入收件人姓名',
        recipientPhone: '收件人手机',
        enterRecipientPhone: '请输入收件人手机号',
        enterRecipientPhone1: '+86 (中国大陆）',
        recipientAdress: '收件人地址',
        addressProvince: '请选择省',
        addressCity: '请选择市',
        addressCounty: '请选择区',
        addressDetail: '详细地址',
        enteraddressDetail: '请输入详细地址',
        isDefaultInvoice1: '设为默认收件地址',
        sure: '确认',
        close: '关闭',
        errorPhone: '手机号格式有误',
        selectAdress: '请选择省份',
    },
    //新增
    targetLibrary: {
        traget: '目标库',
        keywordSearch: '关键词搜索',
        btn: '+ 新建目标点',
        targetPointName: '目标点名称',
        lat: '经度',
        lon: '纬度',
        searchImage: '查存档影像',
        submitProgram: '提编程需求',
        delete: '删除',
        noData: '暂无数据',
        newBuild: '新建目标点',
        name: '名称',
        nameLength: '最多输入十个汉字作为名称',
        transform: '转换',
        reset: '重置',
        submit: '确认',
        alert: '操作提示',
        close: '关闭',
        deleteAlert: '删除提示',
        deleteConfirm: '确认删除',
        cancel: '取消',
    },
    payment:{
        title: '订单提交成功，请尽快付款！',
        paid: '实付',
        payWay: '支付方式',
        wechat: '微信支付',
        duiGong: '对公转账',
        comfirmPay: '确认支付',
        OfflinePayment: '线下支付',
        reminder: '温馨提示',
        alert: '1、财务会在3个工作日内审核并查账，如到账将会在1小时之内对您的订单进行排产，受银行处理时间影响，付款到账可能有所延误。',
        alert1: '2、如果线下汇款过程中遇到任何问题可随时联系',
        customer: '客服 ',
        account: '打款至长光卫星技术股份有限公司指定收款账号',
        account1: '转账途径',
        account2: '银行柜台转账、网上银行',
        account3: '收款户名',
        account4: '长光卫星技术股份有限公司',
        account5: '收款账号',
        account6: '收款银行',
        account7: '建行长春朝阳支行',
        account8: '汇款备注',
        account9: '生态开放商城订单+生态开放商城账户手机号',
        account10: '请妥善保管汇款底单',
        account11: '提交汇款信息',
        account12: '打款至长光卫星技术股份有限公司指定银行账号后，联系',
        account13: '提交您的汇款信息',
        account14: '汇款结果反馈',
        account15: '确定打款操作后，可以在',
        account16: '订单列表',
        account17: '页面查看生产进度',
        ortherWay: '选择其他支付方式',
        scan: '请扫码支付',
        price: '金额',
        scan1: '请使用微信扫一扫，扫描二维码支付',
        bottom: '长光卫星技术股份有限公司2020',
        bottom1: '吉ICP备15001825号-1',
        bottom2: '吉林省长春市北湖科技开发区明溪路1299号',
        call: '联系我们',
        phone1:'电话',
        market:'市场',
        close: '关闭',
        fail: '支付失败',
        back: '返回订单',
        phone: '客服电话',
    },
    programPhotoInfo:{
        myOrder: '我的订单',
        detail: '详情',
        OrderNum: '订单号',
        status: '当前状态',
        money: '金额',
        createTime: '提交时间',
        payTime: '支付时间',
        resource: '来源',
        name: '需求名称',
        type: '服务类型',
        imageTime: '拍摄时间',
        imageMode: '成像模式',
        imageLocation: '成像位置',
        cloud: '云量要求',
        rollSatelliteAngle: '侧摆要求',
        level: '处理级别',
        area: '拍摄面积',
        processDetail: '处理详情',
        shadow: '投影',
        process: '处理',
        pattern: '格式',
        tailor: '剪裁',
        download: '点击下载',
        remark: '备注',
        transitInquiry: '过境查询',
        No: '第',
        No1: '次成像',
        see: '查看',
        link: '下载',
        invoiceInfo: '发票信息',
        noInvoice: '未申请发票',
        reissueInvoice: '补开发票',
        noInvoice1: '暂无优惠券，共抵用0元：使用优惠券0张',
        discount: '优惠券',
        useInvoice: '使用优惠券，共抵用',
        useInvoice1: '元：使用优惠券',
        useInvoice2: '张',
        totalMoney: '总金额',
        discount1: '优惠',
        totalMoney1: '应付总额',
    },

}
